<template>
    <div>
        <modal :show.sync="openFCI" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Fuente Captura de Información</h6>  
                <div class="row">
                    <div v-if="pymeMessage != null" class="alert alert-info">
                        <span>El valor actual del sistema es:<strong> {{ pymeMessage }}</strong></span>
                    </div>  
                    <p-button @click="saveSalesPymeData('Estados financieros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cubes mr-3"></i>
                        Estados financieros
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveSalesPymeData('Software contable')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Software contable
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveSalesPymeData('Registros en excel')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Registros en excel
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveSalesPymeData('Libros contables')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Libros contables
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveSalesPymeData('Otros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Otros
                    </p-button>
                </div>
                <template slot="footer">
                    <div class="left-side">
                        <p-button type="default" link @click="cancelOpenFCI()">Cancelar</p-button>
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">
                        <p-button type="default" link @click="cancelOpenFCI()">Aceptar</p-button>
                    </div>
                </template>       
        </modal>
        <!--Inicia editar ruta-->
        <modal :show.sync="editRoute" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar ruta</h6>
                <div class="form-group">
                    <label>Ruta *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="ruta"
                                placeholder="ruta"
                                autocomplete="off"
                                v-validate="modelValidations.route_name"
                                :error="getError('ruta')"
                                v-model="routeName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.item_name"
                                :error="getError('periodicidad')"
                                v-model="routePeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="routePeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="routePeriodicity == 'Diaria'">
                    <label>Seleccione a continuación los días que viaja en la semana</label>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="routeCheckboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="routeCheckboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="routeCheckboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="routeCheckboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="routeCheckboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                    </div>
                    <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="routeCheckboxes[5].value" :checked="false">S</p-checkbox>
                            <p-checkbox v-model="routeCheckboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                    </div>
                    <div v-if="routesWorkdaysComputed != 0" class="alert alert-warning">
                        <span>Viaja {{routesWorkdaysComputed}} día(s) a la semana</span>
                    </div>
                    <div v-if="routePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de viajes realizados cada día</span>
                    </div>
                    <div class="row">
                        <div v-for="workday in routeCheckboxesComputed" :key="workday.day" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="form-group">
                                <label>{{workday.day}}</label>
                                <fg-input   type="number"
                                            :name="workday.day"
                                            :placeholder="workday.day"
                                            autocomplete="off"
                                            v-validate="modelValidations.sales"
                                            :error="getError(workday.day)"
                                            v-model="workday.sales">
                                </fg-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="routePeriodicity == 'Semanal'">
                    <div v-if="routePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de viajes que hace cada semana</span>
                    </div>
                    <div v-for="weekday in routeWeeks" :key="weekday.week" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Semana {{weekday.week}}</label>
                            <fg-input   type="number"
                                        :name="weekday.week"
                                        :placeholder='`Semana `+weekday.week'
                                        autocomplete="off"
                                        v-validate="modelValidations.sales"
                                        :error="getError(weekday.week)"
                                        v-model="weekday.sales">
                            </fg-input>
                        </div>
                    </div>
                </div>
                <div v-if="routePeriodicity == 'Mensual'">
                    <div v-if="routePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de viajes que hace en un mes</span>
                    </div>
                    <div class="form-group">
                        <label>Viajes en el mes</label>
                        <fg-input   type="number"
                                    name="viajes en el mes"
                                    placeholder="viajes en el mes"
                                    autocomplete="off"
                                    v-validate="modelValidations.sales"
                                    :error="getError('viajes en el mes')"
                                    v-model="routeMonth">
                        </fg-input>
                    </div>
                </div>
                <div class="form-group">
                    <label>Promedio de viajes</label>
                    <fg-input   disabled
                                tabindex="3"
                                type="number"
                                name="promedio de viajes"
                                placeholder="promedio de viajes"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('promedio de viajes')"
                                v-model="routesAverageComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor por viaje *</label>
                    <vue-numeric  :max=999999999999999 tabindex="4" currency="$" autocomplete="off" name="valor por viaje" v-validate="modelValidations.sales" :error="getError('valor por viaje')" separator="." class="form-control" v-model="routeValue "></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Concepto trans *</label>
                    <fg-input   tabindex="5"
                                type="text"
                                name="concepto trans"
                                placeholder="concepto trans"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('concepto trans')"
                                v-model="routeProduct">
                    </fg-input>
                </div>
                <div class="alert alert-warning mt-2">
                    <span>Total venta mes: {{ setFormat(calculatedRouteValue) }}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditRoute()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editRouteToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--Finaliza editar ruta-->
        <!--Inicia agregar ruta-->
        <modal :show.sync="addRoute" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar ruta</h6>
                <div class="form-group">
                    <label>Ruta *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="ruta"
                                placeholder="ruta"
                                autocomplete="off"
                                v-validate="modelValidations.route_name"
                                :error="getError('ruta')"
                                v-model="routeName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.item_name"
                                :error="getError('periodicidad')"
                                v-model="routePeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    @change="resetRoutePeriodicity"
                                    v-model="routePeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="routePeriodicity == 'Diaria'">
                    <label>Seleccione a continuación los días que viaja en la semana</label>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="routeCheckboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="routeCheckboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="routeCheckboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="routeCheckboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="routeCheckboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                    </div>
                    <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="routeCheckboxes[5].value" :checked="false">S</p-checkbox>
                            <p-checkbox v-model="routeCheckboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                    </div>
                    <div v-if="routesWorkdaysComputed != 0" class="alert alert-warning">
                        <span>Viaja {{routesWorkdaysComputed}} día(s) a la semana</span>
                    </div>
                    <div v-if="routePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de viajes realizados cada día</span>
                    </div>
                    <div class="row">
                        <div v-for="workday in routeCheckboxesComputed" :key="workday.day" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="form-group">
                                <label>{{workday.day}}</label>
                                <fg-input   type="number"
                                            :name="workday.day"
                                            :placeholder="workday.day"
                                            autocomplete="off"
                                            v-validate="modelValidations.sales"
                                            :error="getError(workday.day)"
                                            v-model="workday.sales">
                                </fg-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="routePeriodicity == 'Semanal'">
                    <div v-if="routePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de viajes que hace cada semana</span>
                    </div>
                    <div v-for="weekday in routeWeeks" :key="weekday.week" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Semana {{weekday.week}}</label>
                            <fg-input   type="number"
                                        :name="weekday.week"
                                        :placeholder='`Semana `+weekday.week'
                                        autocomplete="off"
                                        v-validate="modelValidations.sales"
                                        :error="getError(weekday.week)"
                                        v-model="weekday.sales">
                            </fg-input>
                        </div>
                    </div>
                </div>
                <div v-if="routePeriodicity == 'Mensual'">
                    <div v-if="routePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de viajes que hace en un mes</span>
                    </div>
                    <div class="form-group">
                        <label>Viajes en el mes</label>
                        <fg-input   type="number"
                                    name="viajes en el mes"
                                    placeholder="viajes en el mes"
                                    autocomplete="off"
                                    v-validate="modelValidations.sales"
                                    :error="getError('viajes en el mes')"
                                    v-model="routeMonth">
                        </fg-input>
                    </div>
                </div>
                <div class="form-group">
                    <label>Promedio de viajes</label>
                    <fg-input   disabled
                                tabindex="3"
                                type="number"
                                name="promedio de viajes"
                                placeholder="promedio de viajes"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('promedio de viajes')"
                                v-model="routesAverageComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor por viaje *</label>
                    <vue-numeric  :max=999999999999999 tabindex="4" currency="$" autocomplete="off" name="valor por viaje" v-validate="modelValidations.sales" :error="getError('valor por viaje')" separator="." class="form-control" v-model="routeValue "></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Concepto trans *</label>
                    <fg-input   tabindex="5"
                                type="text"
                                name="concepto trans"
                                placeholder="concepto trans"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('concepto trans')"
                                v-model="routeProduct">
                    </fg-input>
                </div>
                <div class="alert alert-warning mt-2">
                    <span>Total venta mes: {{ setFormat(calculatedRouteValue) }}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddRoute()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addRouteToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--Finaliza agregar ruta-->
        <!--Inicia Agregar vehiculo-->
        <modal :show.sync="addVehicle" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar vehículo</h6>
                <div class="form-group">
                    <label>Vehículo *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="vehiculo"
                                placeholder="vehiculo"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('vehiculo')"
                                v-model="vehicleName">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddVehicle()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addVehicleToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--Finaliza agregar vehiculo-->
        <!--Inicia Editar vehiculo-->
        <modal :show.sync="editVehicle" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar vehículo</h6>
                <div class="form-group">
                    <label>Vehículo *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="vehiculo"
                                placeholder="vehiculo"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('vehiculo')"
                                v-model="vehicleName">
                    </fg-input>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditVehicle()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editVehicleToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--Finaliza editar vehiculo-->
        <!-- Inicia Pyme Modal -->
        <modal  :show.sync="modalProjectedSales" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Ventas Proyectadas</h6>
            <el-table v-if="projectedSalesHistoricalMonthData.length" :data="projectedSalesHistoricalMonthData">
                <el-table-column prop="label" label="Mes"></el-table-column>
                <el-table-column prop="value" label="Valor Proyectado"></el-table-column>
            </el-table>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelModalProjectedSales()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                
                </div>
            </template>
        </modal> 
        <!-- Finaliza Pyme Modal -->
        <modal :show.sync="addService" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar ítem</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('nombre')"
                                v-model="serviceName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.item_name"
                                :error="getError('periodicidad')"
                                v-model="servicePeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="servicePeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Quincenal"
                                    label="Quincenal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <hr v-if="servicePeriodicity != ''" class="hr-orange">
                <div v-if="servicePeriodicity == 'Diaria'">
                    <label>Seleccione a continuación los días que trabaja en la semana</label>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="serviceCheckboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="serviceCheckboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="serviceCheckboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="serviceCheckboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="serviceCheckboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                    </div>
                    <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="serviceCheckboxes[5].value" :checked="false">S</p-checkbox>
                            <p-checkbox v-model="serviceCheckboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                    </div>
                    <div v-if="serviceWorkdaysComputed != 0" class="alert alert-warning">
                        <span>Trabaja {{serviceWorkdaysComputed}} día(s) a la semana</span>
                    </div>
                    <div v-if="servicePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas cada día</span>
                    </div>
                    <div class="row">
                        <div v-for="workday in serviceCheckboxesComputed" :key="workday.day" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="form-group">
                                <label>{{workday.day}}</label>
                                <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="workday.day" v-validate="modelValidations.sales" :error="getError(workday.day)" separator="." class="form-control" v-model="workday.sales"></vue-numeric>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="servicePeriodicity == 'Semanal'">
                    <div v-if="servicePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas cada semana</span>
                    </div>
                    <div v-for="weekday in serviceWeeks" :key="weekday.week" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Semana {{weekday.week}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="weekday.week" v-validate="modelValidations.sales" :error="getError(weekday.week)" separator="." class="form-control" v-model="weekday.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="servicePeriodicity == 'Quincenal'">
                    <div v-if="servicePeriodicity != ''" class="alert alert-info">
                        <span>A continuación ingrese la cantidad de unidades producidas cada quincena</span>
                    </div>
                    <div v-for="biweek in serviceBiweeks" :key="biweek.biweek" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Quincena {{biweek.biweek}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="biweek.biweek" v-validate="modelValidations.sales" :error="getError(biweek.biweek)" separator="." class="form-control" v-model="biweek.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div v-if="servicePeriodicity == 'Mensual'">
                    <div v-if="servicePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas en el mes</span>
                    </div>
                    <div class="form-group">
                        <label>Mes</label>
                        <vue-numeric  :max=999999999999999 currency="" autocomplete="off" name="mes" v-validate="modelValidations.sales" :error="getError('mes')" separator="." class="form-control" v-model="serviceMonth"></vue-numeric>
                    </div>
                </div>
                <div class="form-group">
                    <label>Promedio unidades mes*</label>
                    <fg-input   disabled
                                tabindex="1"
                                type="number"
                                name="promedio unidades"
                                placeholder="promedio unidades"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('promedio unidades')"
                                v-model="monthlyServiceComputed">
                    </fg-input>
                </div>
                <div v-if="servicePeriodicity == 'Diaria'" class="form-group">
                    <label>Tiempo usado unidad</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="tiempo usado unidad"
                                placeholder="tiempo usado unidad"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('tiempo usado unidad')"
                                v-model="serviceTime">
                    </fg-input>
                </div>
                <div v-if="servicePeriodicity == 'Diaria'" class="form-group">
                    <label>Tiempo promedio diario</label>
                    <fg-input   disabled
                                tabindex="3"
                                type="string"
                                name="tiempo total"
                                placeholder="tiempo total"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('tiempo total')"
                                v-model="serviceTimeComputed">
                    </fg-input>
                </div>
                <hr v-if="servicePeriodicity != ''" class="hr-orange">
                <div class="form-group">
                    <label>Precio de venta unitario*</label>
                    <vue-numeric  :max=999999999999999 tabindex="4" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="serviceSaleValue"></vue-numeric>
                </div>
                <!--<div class="form-group">
                    <label>Tipo de costeo de insumos *</label>
                    <fg-input   tabindex="3"
                                name="tipo de costeo"
                                v-validate="modelValidations.product_name"
                                :error="getError('tipo de costeo')"
                                v-model="productSelect">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productSelect">
                            <el-option class="select-warning"
                                    value="unit"
                                    label="Individual">
                            </el-option>
                            <el-option class="select-warning"
                                    value="total"
                                    label="Total">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>-->
                <div v-if="serviceTotalSaleComputed != 0" class="alert alert-warning mt-2">
                    <span>Total: {{ setFormat(serviceTotalSaleComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddService()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="serviceTotalSaleComputed != 0" type="default" link @click="addServiceToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editService" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar ítem</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('nombre')"
                                v-model="serviceName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.item_name"
                                :error="getError('periodicidad')"
                                v-model="servicePeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="servicePeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Quincenal"
                                    label="Quincenal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <hr v-if="servicePeriodicity != ''" class="hr-orange">
                <div v-if="servicePeriodicity == 'Diaria'">
                    <label>Seleccione a continuación los días que trabaja en la semana</label>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="serviceCheckboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="serviceCheckboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="serviceCheckboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="serviceCheckboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="serviceCheckboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                    </div>
                    <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="serviceCheckboxes[5].value" :checked="false">S</p-checkbox>
                            <p-checkbox v-model="serviceCheckboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                    </div>
                    <div v-if="serviceWorkdaysComputed != 0" class="alert alert-warning">
                        <span>Trabaja {{serviceWorkdaysComputed}} día(s) a la semana</span>
                    </div>
                    <div v-if="servicePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas cada día</span>
                    </div>
                    <div class="row">
                        <div v-for="workday in serviceCheckboxesComputed" :key="workday.day" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="form-group">
                                <label>{{workday.day}}</label>
                                <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="workday.day" v-validate="modelValidations.sales" :error="getError(workday.day)" separator="." class="form-control" v-model="workday.sales"></vue-numeric>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="servicePeriodicity == 'Semanal'">
                    <div v-if="servicePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas cada semana</span>
                    </div>
                    <div v-for="weekday in serviceWeeks" :key="weekday.week" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Semana {{weekday.week}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="weekday.week" v-validate="modelValidations.sales" :error="getError(weekday.week)" separator="." class="form-control" v-model="weekday.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="servicePeriodicity == 'Quincenal'">
                    <div v-if="servicePeriodicity != ''" class="alert alert-info">
                        <span>A continuación ingrese la cantidad de unidades producidas cada quincena</span>
                    </div>
                    <div v-for="biweek in serviceBiweeks" :key="biweek.biweek" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Quincena {{biweek.biweek}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="biweek.biweek" v-validate="modelValidations.sales" :error="getError(biweek.biweek)" separator="." class="form-control" v-model="biweek.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div v-if="servicePeriodicity == 'Mensual'">
                    <div v-if="servicePeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas en el mes</span>
                    </div>
                    <div class="form-group">
                        <label>Mes</label>
                        <vue-numeric  :max=999999999999999 currency="" autocomplete="off" name="mes" v-validate="modelValidations.sales" :error="getError('mes')" separator="." class="form-control" v-model="serviceMonth"></vue-numeric>
                    </div>
                </div>
                <div class="form-group">
                    <label>Promedio unidades *</label>
                    <fg-input   disabled
                                tabindex="1"
                                type="number"
                                name="promedio unidades"
                                placeholder="promedio unidades"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('promedio unidades')"
                                v-model="monthlyServiceComputed">
                    </fg-input>
                </div>
                <div  v-if="servicePeriodicity == 'Diaria'" class="form-group">
                    <label>Tiempo usado unidad</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="tiempo usado unidad"
                                placeholder="tiempo usado unidad"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('tiempo usado unidad')"
                                v-model="serviceTime">
                    </fg-input>
                </div>
                <div  v-if="servicePeriodicity == 'Diaria'" class="form-group">
                    <label>Tiempo promedio diario</label>
                    <fg-input   disabled
                                tabindex="3"
                                type="string"
                                name="tiempo total"
                                placeholder="tiempo total"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('tiempo total')"
                                v-model="serviceTimeComputed">
                    </fg-input>
                </div>
                <hr v-if="servicePeriodicity != ''" class="hr-orange">
                <div class="form-group">
                    <label>Precio de venta unitario*</label>
                    <vue-numeric  :max=999999999999999 tabindex="2" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="serviceSaleValue"></vue-numeric>
                </div>
                <!--<div class="form-group">
                    <label>Tipo de costeo de insumos *</label>
                    <fg-input   tabindex="3"
                                name="tipo de costeo"
                                v-validate="modelValidations.product_name"
                                :error="getError('tipo de costeo')"
                                v-model="productSelect">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productSelect">
                            <el-option class="select-warning"
                                    value="unit"
                                    label="Individual">
                            </el-option>
                            <el-option class="select-warning"
                                    value="total"
                                    label="Total">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>-->
                <div v-if="serviceTotalSaleComputed != 0" class="alert alert-warning mt-2">
                    <span>Total: {{ setFormat(serviceTotalSaleComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditService()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="serviceTotalSaleComputed != 0" type="default" link @click="editServiceToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar producto</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('nombre')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.item_name"
                                :error="getError('periodicidad')"
                                v-model="productPeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productPeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Quincenal"
                                    label="Quincenal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <hr v-if="productPeriodicity != ''" class="hr-orange">
                <div v-if="productPeriodicity == 'Diaria'">
                    <label>Seleccione a continuación los días que trabaja en la semana</label>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="productCheckboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="productCheckboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="productCheckboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="productCheckboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="productCheckboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                    </div>
                    <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="productCheckboxes[5].value" :checked="false">S</p-checkbox>
                            <p-checkbox v-model="productCheckboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                    </div>
                    <div v-if="productWorkdaysComputed != 0" class="alert alert-warning">
                        <span>Trabaja {{productWorkdaysComputed}} día(s) a la semana</span>
                    </div>
                    <div v-if="productPeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas cada día</span>
                    </div>
                    <div class="row">
                        <div v-for="workday in productCheckboxesComputed" :key="workday.day" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="form-group">
                                <label>{{workday.day}}</label>
                                <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="workday.day" v-validate="modelValidations.sales" :error="getError(workday.day)" separator="." class="form-control" v-model="workday.sales"></vue-numeric>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="productPeriodicity == 'Semanal'">
                    <div v-if="productPeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas cada semana</span>
                    </div>
                    <div v-for="weekday in productWeeks" :key="weekday.week" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Semana {{weekday.week}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="weekday.week" v-validate="modelValidations.sales" :error="getError(weekday.week)" separator="." class="form-control" v-model="weekday.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="productPeriodicity == 'Quincenal'">
                    <div v-if="productPeriodicity != ''" class="alert alert-info">
                        <span>A continuación ingrese la cantidad de unidades producidas cada quincena</span>
                    </div>
                    <div v-for="biweek in productBiweeks" :key="biweek.biweek" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Quincena {{biweek.biweek}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="biweek.biweek" v-validate="modelValidations.sales" :error="getError(biweek.biweek)" separator="." class="form-control" v-model="biweek.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div v-if="productPeriodicity == 'Mensual'">
                    <div v-if="productPeriodicity != ''" class="alert alert-info mt-2">
                        <span>A continuación ingrese la cantidad de unidades producidas en el mes</span>
                    </div>
                    <div class="form-group">
                        <label>Mes</label>
                        <vue-numeric  :max=999999999999999 currency="" autocomplete="off" name="mes" v-validate="modelValidations.sales" :error="getError('mes')" separator="." class="form-control" v-model="productMonth"></vue-numeric>
                    </div>
                </div>
                <hr v-if="productPeriodicity != ''" class="hr-orange">
                <div class="form-group">
                    <label>Promedio producción *</label>
                    <fg-input   disabled
                                tabindex="1"
                                type="number"
                                name="promedio mes"
                                placeholder="promedio mes"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('promedio mes')"
                                v-model="monthlyAverageComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de venta unitario*</label>
                    <vue-numeric  :max=999999999999999 tabindex="2" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="productSaleValue"></vue-numeric>
                </div>
                <!--<div class="form-group">
                    <label>Tipo de costeo de insumos *</label>
                    <fg-input   tabindex="3"
                                name="tipo de costeo"
                                v-validate="modelValidations.product_name"
                                :error="getError('tipo de costeo')"
                                v-model="productSelect">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productSelect">
                            <el-option class="select-warning"
                                    value="unit"
                                    label="Individual">
                            </el-option>
                            <el-option class="select-warning"
                                    value="total"
                                    label="Total">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>-->
                <div v-if="productTotalSaleComputed != 0" class="alert alert-warning mt-2">
                    <span>Total: {{ setFormat(productTotalSaleComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="productTotalSaleComputed != 0" type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar producto</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('nombre')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.item_name"
                                :error="getError('periodicidad')"
                                v-model="productPeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productPeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Quincenal"
                                    label="Quincenal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="productPeriodicity == 'Diaria'">
                    <label>Seleccione a continuación los días que trabaja en la semana</label>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="productCheckboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="productCheckboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="productCheckboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="productCheckboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="productCheckboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                    </div>
                    <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="productCheckboxes[5].value" :checked="false">S</p-checkbox>
                            <p-checkbox v-model="productCheckboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                    </div>
                    <div v-if="productWorkdaysComputed != 0" class="alert alert-warning">
                        <span>Trabaja {{productWorkdaysComputed}} día(s) a la semana</span>
                    </div>
                    <div class="row">
                        <div v-for="workday in productCheckboxesComputed" :key="workday.day" class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                            <div class="form-group">
                                <label>{{workday.day}}</label>
                                <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="workday.day" v-validate="modelValidations.sales" :error="getError(workday.day)" separator="." class="form-control" v-model="workday.sales"></vue-numeric>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="productPeriodicity == 'Semanal'">
                    <div v-for="weekday in productWeeks" :key="weekday.week" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Semana {{weekday.week}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="weekday.week" v-validate="modelValidations.sales" :error="getError(weekday.week)" separator="." class="form-control" v-model="weekday.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="productPeriodicity == 'Quincenal'">
                    <div v-for="biweek in productBiweeks" :key="biweek.biweek" class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Quincena {{biweek.biweek}}</label>
                            <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :name="biweek.biweek" v-validate="modelValidations.sales" :error="getError(biweek.biweek)" separator="." class="form-control" v-model="biweek.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div v-if="productPeriodicity == 'Mensual'">
                    <div class="form-group">
                        <label>Mes</label>
                        <vue-numeric  :max=999999999999999 currency="" autocomplete="off" name="mes" v-validate="modelValidations.sales" :error="getError('mes')" separator="." class="form-control" v-model="productMonth"></vue-numeric>
                    </div>
                </div>
                <div class="form-group">
                    <label>Promedio producción *</label>
                    <fg-input   disabled
                                tabindex="1"
                                type="number"
                                name="promedio mes"
                                placeholder="promedio mes"
                                autocomplete="off"
                                v-validate="modelValidations.sales"
                                :error="getError('promedio mes')"
                                v-model="monthlyAverageComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de venta unitario*</label>
                    <vue-numeric  :max=999999999999999 tabindex="2" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="productSaleValue"></vue-numeric>
                </div>
                <!--<div class="form-group">
                    <label>Tipo de costeo de insumos *</label>
                    <fg-input   tabindex="3"
                                name="tipo de costeo"
                                v-validate="modelValidations.product_name"
                                :error="getError('tipo de costeo')"
                                v-model="productSelect">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productSelect">
                            <el-option class="select-warning"
                                    value="unit"
                                    label="Individual">
                            </el-option>
                            <el-option class="select-warning"
                                    value="total"
                                    label="Total">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>-->
                <div v-if="productTotalSaleComputed != 0" class="alert alert-warning mt-2">
                    <span>Total: {{ setFormat(productTotalSaleComputed)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="productTotalSaleComputed != 0" type="default" link @click="editProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Seleccione cruce de ventas</h6>
                <p-button v-if="pyme" class="top-right-button" type="primary" @click="openFCIMethod()">FCI</p-button>
            </div>
            <div class="card-body">
                <div class="row">
                    <div v-if="pyme" class="col-md-12">
                        <p-switch type="warning" v-model="switches.historical">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Histórico mes base</label>
                    </div>
                    <div v-if="pyme && !hideVehicles" class="col-md-12">
                        <p-switch type="warning" v-model="switches.travel">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Por viaje</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.daily">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Diario</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.weekly">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Semanal</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.monthly">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Mensual</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.product">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Por producto</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.average">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Promedio</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.service">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Cantidad</label>
                    </div>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!--Inicia historical data-->
        <card v-if="switches.historical" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Proyección de ventas</h6>
                <p-button v-if="historicalDate != null" class="top-right-button" type="primary" @click="projectedSalesModal()">Ventas proyectadas</p-button>
            </div>
            <div class="card-body">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Fecha inicial</label>
                        <el-date-picker
                            v-model="historicalDate"
                            type="month"
                            placeholder="Seleccione fecha inicial">
                        </el-date-picker>
                    </div>
                </div>
                <div v-if="historicalDate != null" class="col-md-12" style="width: 100%;">
                    <el-table :data="computedHistoricalMonthData" style="width: 100%;">
                        <el-table-column :min-width="60" prop="inputValue" label="Ventas históricas">
                            <template slot-scope="scope">
                                <label>{{scope.row.label}}</label>
                                <vue-numeric  :max=999999999999999 currency="" autocomplete="off" :placeholder="`Ingrese ${scope.row.label}`" :name="scope.row.label" v-validate="modelValidations.sales" :error="getError(scope.row.label)" separator="." class="form-control" v-model="scope.row.inputValue"></vue-numeric>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column :min-width="20" prop="value" label="Variación %">
                            <template slot-scope="scope">
                            {{ scope.row.variation }}
                            </template>
                        </el-table-column> -->
                        <el-table-column :min-width="20" prop="variation" label="Variación (%)">
                            <template slot-scope="scope">
                            <span :class="getVariationClass(scope.row.variation)">
                                {{ scope.row.variation !== null ? scope.row.variation.toFixed(2) : 'N/A' }}
                            </span>
                            </template>
                        </el-table-column>
                        <el-table-column :min-width="20">
                            <template slot-scope="scope">
                                <p-checkbox v-model="scope.row.checked" :checked="false"></p-checkbox>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="historical_sales_computed != 0 && historicalDate != null" class="alert alert-warning mt-2">
                    <span>Ventas promedio Mes Base: {{ setFormat(historical_sales_computed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!--Finaliza historical data-->
         <!--Inicia cruce por viajes-->
         <card v-if="switches.travel && !hideVehicles" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Cruce por viaje</h6>
            </div>
            <div class="card-body">
                <el-table v-if="vehicles.length" :data="vehicles"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Vehículo: {{ props.row.vehicleName }}</p>
                            <p>Venta: {{ setFormat(props.row.vehicleSales) }}</p>
                            <h5 v-if="props.row.routes.length > 0" style="color: #FFA20B;">Rutas</h5>
                            <el-table ref="routesTable" highlight-current-row @current-change="handleCurrentRouteChange" v-if="props.row.routes.length > 0" :data="props.row.routes">
                                <el-table-column label="Ítem" property="routeName"></el-table-column>
                                <el-table-column label="Valor">
                                    <template slot-scope="scope">
                                        <span >{{ setFormat(scope.row.routeTotal )}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <br>
                            <div v-if="props.row.routes.length < 10">
                                <p-button 
                                    @click="addRouteMethod(props.$index)"
                                    type="default" 
                                    >
                                    <i class="mr-2 fa fa-plus"></i>Agregar ruta
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentRouteRow">
                                <p-button 
                                    @click="editRouteMethod(props.$index)"
                                    type="default" >
                                    <i class="mr-2 fa fa-pencil"></i>Editar ruta
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentRouteRow">
                                <p-button 
                                    @click="removeRoute(props.$index)"
                                    type="default" >
                                    <i class="mr-2 fa fa-minus"></i>Quitar ruta
                                </p-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Vehículo" property="vehicleName"></el-table-column>
                    <el-table-column label="Ventas">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.vehicleSales)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        v-if="vehicles.length < 12"
                        @click="addVehicleMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar vehículo
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editVehicleMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar vehículo
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeVehicleMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar vehículo
                    </p-button>
                </div>
                <!-- <div v-if="allProductsMonthlyCostComputed != 0" class="alert alert-warning mt-2">
                    <span>Costo promedio mes: {{setFormat(allProductsMonthlyCostComputed)}}</span>
                </div> -->
            </div>
            <div class="card-footer">
                <div v-if="travel_sales_computed != 0 && vehicles != null" class="alert alert-warning mt-2">
                    <span>Ventas mensuales por viajes: {{ setFormat(travel_sales_computed)}}</span>
                </div>
            </div>
        </card>
        <!--Finaliza cruce por viajes-->
        <card v-if="switches.daily" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Cruce diario</h6>
                <label>Seleccione a continuación los días que trabaja en la semana</label>
            </div>
            <div class="card-body">
                <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="checkboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="checkboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="checkboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="checkboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="checkboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                </div>
                <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="checkboxes[5].value" :checked="false">S</p-checkbox>
                        <p-checkbox v-model="checkboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                </div>
                <div v-if="workdays_computed != 0" class="alert alert-warning">
                    <span>Trabaja {{workdays_computed}} día(s) a la semana</span>
                </div>
                <div class="row">
                    <div v-for="workday in checkboxes_computed" :key="workday.day" class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>{{workday.day}}</label>
                            <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" :name="workday.day" v-validate="modelValidations.sales" :error="getError(workday.day)" separator="." class="form-control" v-model="workday.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div v-if="workdays_sales_computed != 0" class="alert alert-warning mt-2">
                    <span>Total ventas mensual: {{ setFormat(workdays_sales_computed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <card v-if="switches.weekly" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Cruce semanal</h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div v-for="weekday in weeks" :key="weekday.week" class="col-md-4 col-lg-3 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Semana {{weekday.week}}</label>
                            <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" :name="weekday.week" v-validate="modelValidations.sales" :error="getError(weekday.week)" separator="." class="form-control" v-model="weekday.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div v-if="weekdays_sales_computed != 0" class="alert alert-warning mt-2">
                    <span>Total ventas mensual: {{ setFormat(weekdays_sales_computed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <card v-if="switches.monthly" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Cruce mensual</h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div v-for="month in months" :key="month.month" class="col-md-4 col-lg-3 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>Mes {{month.month}}</label>
                            <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" :name="month.month" v-validate="modelValidations.sales" :error="getError(month.month)" separator="." class="form-control" v-model="month.sales"></vue-numeric>
                        </div>
                    </div>
                </div>
                <div>
                    <p-button 
                        @click="addMonth()"
                        type="default" >
                        <i class="mr-2 fa fa-plus"></i>Agregar mes
                    </p-button>
                </div>
                <div v-if="months.length > 3">
                    <p-button 
                        @click="removeMonth()"
                        type="default" >
                        <i class="mr-2 fa fa-minus"></i>Quitar mes
                    </p-button>
                </div>
                <div v-if="months_sales_computed != 0" class="alert alert-warning mt-2">
                    <span>Promedio ventas mensual: {{ setFormat(months_sales_computed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <card v-if="switches.product" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Cruce de producto</h6>
            </div>
            <div class="card-body">
                <el-table ref="productsTable"  @row-dblclick="editProductMethod" highlight-current-row @current-change="handleCurrentChange" v-if="products.length" :data="products">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Producto: {{ props.row.productName }}</p>
                            <p>Periodicidad: {{ props.row.productPeriodicity }}</p>
                            <p>Promedio ventas mensuales: {{ props.row.productSaleMonthly }}</p>
                            <p>Valor unitario: {{ setFormat(props.row.productSaleValue) }}</p>
                            <p>Total: {{ setFormat(props.row.productTotalSale) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Producto" property="productName"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.productTotalSale)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div>
                    <p-button 
                        v-if="!verifyCostsLocked()"
                        :disabled="verifyCostsLocked()"
                        @click="addProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar producto
                    </p-button>
                    <br>
                    <p-button 
                        :disabled="verifyCostsLocked()"
                        v-if="!verifyCostsLocked() && currentRow" 
                        @click="editProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar producto
                    </p-button>
                    <br>
                    <p-button 
                        :disabled="verifyCostsLocked()"
                        v-if="!verifyCostsLocked() && currentRow" 
                        @click="removeProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar producto
                    </p-button>
                </div>
                <div v-if="products_sales_computed != 0" class="alert alert-warning mt-2">
                    <span>Promedio ventas mensual: {{ setFormat(products_sales_computed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <card v-if="switches.average" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Cruce de promedio</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.average_selection"
                                :error="getError('periodicidad')"
                                v-model="average.periodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="average.periodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Diaria"
                                    label="Diaria">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Semanal"
                                    label="Semanal">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="average.periodicity == 'Diaria' && !switches.daily" >
                    <label>Seleccione a continuación los días que trabaja en la semana</label>
                    <br>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="checkboxes[0].value" :checked="false">L</p-checkbox>
                        <p-checkbox v-model="checkboxes[1].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="checkboxes[2].value" class="ml-2" :checked="false">M</p-checkbox>
                        <p-checkbox v-model="checkboxes[3].value" class="ml-2" :checked="false">J</p-checkbox>
                        <p-checkbox v-model="checkboxes[4].value" class="ml-2" :checked="false">V</p-checkbox>
                    </div>
                    <div class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="checkboxes[5].value" :checked="false">S</p-checkbox>
                            <p-checkbox v-model="checkboxes[6].value" class="ml-2" :checked="false">D</p-checkbox>
                    </div>
                </div>
                <div v-if="average.periodicity == 'Diaria' && workdays_computed != 0" class="alert alert-warning">
                    <span>Trabaja {{workdays_computed}} día(s) a la semana</span>
                </div>
                <div class="form-group">
                    <label>Venta buena</label>
                    <vue-numeric  :max=999999999999999 tabindex="10" currency="$" autocomplete="off" name="Venta buena" v-validate="modelValidations.sales" :error="getError('Venta buena')" separator="." class="form-control" v-model="average.good_sale"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Venta regular</label>
                    <vue-numeric  :max=999999999999999 tabindex="11" currency="$" autocomplete="off" name="Venta regular" v-validate="modelValidations.sales" :error="getError('Venta regular')" separator="." class="form-control" v-model="average.regular_sale"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Venta mala</label>
                    <vue-numeric  :max=999999999999999 tabindex="12" currency="$" autocomplete="off" name="Venta mala" v-validate="modelValidations.sales" :error="getError('Venta mala')" separator="." class="form-control" v-model="average.bad_sale"></vue-numeric>
                </div>
                <!--<div class="form-group">
                    <label>Promedio</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="Promedio" v-validate="modelValidations.sales" :error="getError('Promedio')" separator="." class="form-control" :value="average_sales_computed"></vue-numeric>
                </div>-->
                <div v-if="average_sales_computed != 0" class="alert alert-warning">
                    <span>Promedio: {{ setFormat(average_sales_computed)}}</span>
                </div>
                <div v-if="average_monthly_sales_computed != 0" class="alert alert-warning">
                    <span>Total ventas mensual: {{ setFormat(average_monthly_sales_computed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <card v-if="switches.service" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Cruce de cantidad</h6>
            </div>
            <div class="card-body">
                <el-table ref="servicesTable"  @row-dblclick="editServiceMethod" highlight-current-row @current-change="handleCurrentChange" v-if="services.length" :data="services">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Servicio: {{ props.row.serviceName }}</p>
                            <p>Periodicidad: {{ props.row.servicePeriodicity }}</p>
                            <p>Promedio ventas mensuales: {{ props.row.serviceSaleMonthly }}</p>
                            <p v-if="props.row.serviceTimeTotal != 0">Tiempo usado unidad: {{ props.row.serviceTime }}</p>
                            <p v-if="props.row.serviceTimeTotal != 0">Tiempo promedio diario: {{ timeConverter(props.row.serviceTimeTotal) }}</p>
                            <p>Valor unitario: {{ setFormat(props.row.serviceSaleValue) }}</p>
                            <p>Total: {{ setFormat(props.row.serviceTotalSale) }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Servicio" property="serviceName"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.serviceTotalSale)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div>
                    <p-button 
                        @click="addServiceMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar ítem
                    </p-button>
                    <br>
                    <p-button 
                        v-if="currentRow" 
                        @click="editServiceMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar ítem
                    </p-button>
                    <br>
                    <p-button 
                        v-if="currentRow" 
                        @click="removeServiceMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar ítem
                    </p-button>
                </div>
                <div v-if="services_sales_computed != 0" class="alert alert-warning mt-2">
                    <span>Promedio ventas mensual: {{ setFormat(services_sales_computed)}}</span>
                </div>
                <div v-if="serviceTimeTotalComputed != 0" class="alert alert-warning mt-2">
                    <span>Total promedio diario: {{ serviceTimeTotalComputed}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <card  v-if="minimum_sales_computed != 0" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Selección manual</h6>
            </div>
            <div class="card-body">
                <div class="row">
                    <div v-if="minimum_sales_computed != 0" class="alert alert-success">
                        <span>El valor de ventas sugerido por el sistema es: {{ setFormat(minimum_sales_computed)}}. Si desea seleccionar el valor manualmente escoja uno de los siguientes valores: </span>
                    </div>
                    <div>
                        <div v-if="switches.historical" class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="manually.historical" :checked="false">Mes base: {{ setFormat(historical_sales_computed)}}</p-checkbox>
                        </div>
                        <div v-if="switches.travel" class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="manually.travel" :checked="false">Por viajes: {{ setFormat(travel_sales_computed)}}</p-checkbox>
                        </div>
                        <div v-if="switches.daily" class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="manually.daily" :checked="false">Diario: {{ setFormat(workdays_sales_computed)}}</p-checkbox>
                        </div>
                        <div v-if="switches.weekly" class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="manually.weekly" :checked="false">Semanal: {{ setFormat(weekdays_sales_computed)}}</p-checkbox>
                        </div>
                        <div v-if="switches.monthly" class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="manually.monthly" :checked="false">Mensual: {{ setFormat(months_sales_computed)}}</p-checkbox>
                        </div>
                        <div v-if="switches.product" class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="manually.product" :checked="false">Por producto: {{ setFormat(products_sales_computed)}}</p-checkbox>
                        </div>
                        <div v-if="switches.average" class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="manually.average" :checked="false">Promedio: {{ setFormat(average_monthly_sales_computed)}}</p-checkbox>
                        </div>
                        <div v-if="switches.service" class="row" style="margin: 0 0 12px;">
                            <p-checkbox v-model="manually.service" :checked="false">Por cantidad: {{ setFormat(services_sales_computed)}}</p-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div v-if="minimum_sales_computed != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(final_minimum_sales_computed)}}</span>
        </div>
        <div v-if="costs_computed != 0" class="alert alert-success">
            <span>Costos mensuales: {{ setFormat(costs_computed)}}</span>
        </div>
        <div class="text-right">
            <p-button v-if="validateSwitch()" @click="saveSales()" type="warning">Siguiente</p-button>
            <p-button @click="toSalesCostsSelection()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Input, Select, Option, Table, TableColumn, DatePicker, Checkbox} from 'element-ui'
    import moment from 'moment'
    import LineChart from 'src/components/UIComponents/Charts/LineChart'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    const tooltipOptions = {
        tooltipFillColor: "rgba(0,0,0,0.5)",
        tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        tooltipFontSize: 14,
        tooltipFontStyle: "normal",
        tooltipFontColor: "#fff",
        tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        tooltipTitleFontSize: 14,
        tooltipTitleFontStyle: "bold",
        tooltipTitleFontColor: "#fff",
        tooltipYPadding: 6,
        tooltipXPadding: 6,
        tooltipCaretSize: 8,
        tooltipCornerRadius: 6,
        tooltipXOffset: 10,
    };
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            LineChart,
            [Checkbox.name]: Checkbox,
            [Input.name]: Input,
            [DatePicker.name]: DatePicker,
        },
        data() {
        return {
            historicalBaseMonth: {
                value: null,
                variation: null
            },
            routes: {
                general: null,
                produccion: null,
                transporte: null,
                serviciogeneral: null

            },
            currentRouteRow: null,
            addRouteIndex: null,
            editRouteIndex: null,
            form: {
                average_selection: '',
            },
            openFCI: false,
            pymeMessage: false,
            hideVehicles: true,
            ipc: null,
            projectedSalesHistoricalMonthData: [],
            historicalDate: null, // Inicialmente nulo o indefinido
            historicalAVG: null,
            historical: [], // Array que será recalculado
            modalProjectedSales: false,
            pyme: false,
            pymeModal: false,
            pymeChartModal: false,
            minimumSalesVar: 0,
            costsChange: false,
            currentRow: null,
            routeName: '',
            routePeriodicity: '',
            routeQuantity: null,
            routeMonth: null,
            routeProduct: '',
            routeValue: '',
            vehicleName: '',
            productDaily: '',
            productWeekly: '',
            productMonthly: '',
            productValue: '',
            productMonthlyValue: '',
            productName: '',
            productPeriodicity: '',
            productSaleValue: '',
            productMonth: '',
            productSaleMonthly: '',
            productTotalSale: '',
            productCostPercent: 0,
            serviceCurrentRow: null,
            serviceDaily: '',
            serviceWeekly: '',
            serviceMonthly: '',
            serviceValue: '',
            serviceMonthlyValue: '',
            serviceName: '',
            servicePeriodicity: '',
            serviceSaleValue: '',
            serviceMonth: '',
            serviceTime: '',
            serviceTimeTotal: '',
            serviceSaleMonthly: '',
            serviceTotalSale: '',
            productSelect: 'unit',
            productMultiplier: 1,
            productCheckboxes: [
                {
                    day: "Lunes",
                    char: "L",
                    value: true,
                    sales: ''
                },
                {
                    day: "Martes",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Miércoles",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Jueves",
                    char: "J",
                    value: true,
                    sales: ''
                },
                {
                    day: "Viernes",
                    char: "V",
                    value: true,
                    sales: ''
                },
                {
                    day: "Sábado",
                    char: "S",
                    value: true,
                    sales: ''
                },
                {
                    day: "Domingo",
                    char: "D",
                    value: true,
                    sales: ''
                },
            ],
            serviceCheckboxes: [
                {
                    day: "Lunes",
                    char: "L",
                    value: true,
                    sales: ''
                },
                {
                    day: "Martes",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Miércoles",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Jueves",
                    char: "J",
                    value: true,
                    sales: ''
                },
                {
                    day: "Viernes",
                    char: "V",
                    value: true,
                    sales: ''
                },
                {
                    day: "Sábado",
                    char: "S",
                    value: true,
                    sales: ''
                },
                {
                    day: "Domingo",
                    char: "D",
                    value: true,
                    sales: ''
                },
            ],
            routeCheckboxes: [
                {
                    day: "Lunes",
                    char: "L",
                    value: true,
                    sales: ''
                },
                {
                    day: "Martes",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Miércoles",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Jueves",
                    char: "J",
                    value: true,
                    sales: ''
                },
                {
                    day: "Viernes",
                    char: "V",
                    value: true,
                    sales: ''
                },
                {
                    day: "Sábado",
                    char: "S",
                    value: true,
                    sales: ''
                },
                {
                    day: "Domingo",
                    char: "D",
                    value: true,
                    sales: ''
                },
            ],
            productWeeks: [
                {
                    week: '1',
                    sales: ''
                },
                {
                    week: '2',
                    sales: ''
                },
                {
                    week: '3',
                    sales: ''
                },
                {
                    week: '4',
                    sales: ''
                }
            ],
            serviceWeeks: [
                {
                    week: '1',
                    sales: ''
                },
                {
                    week: '2',
                    sales: ''
                },
                {
                    week: '3',
                    sales: ''
                },
                {
                    week: '4',
                    sales: ''
                }
            ],
            routeWeeks: [
                {
                    week: '1',
                    sales: ''
                },
                {
                    week: '2',
                    sales: ''
                },
                {
                    week: '3',
                    sales: ''
                },
                {
                    week: '4',
                    sales: ''
                }
            ],
            productBiweeks: [
                {
                    biweek: '1',
                    sales: ''
                },
                {
                    biweek: '2',
                    sales: ''
                }
            ],
            serviceBiweeks: [
                {
                    biweek: '1',
                    sales: ''
                },
                {
                    biweek: '2',
                    sales: ''
                }
            ],
            serviceDailyCheckboxes: false,
            productDailyCheckboxes: false,
            switches: {
                historical: false, //Cruce de ventas histórico
                travel: false, //Cruce de ventas por viaje
                daily: false, //Cruce de ventas diario
                weekly: false, //Cruce de ventas semanal
                monthly: false, //Cruce de ventas mensual
                product: false, //Cruce de ventas por producto
                average: false, //Cruce de ventas por promedio
                service: false, //Cruce de ventas por servicio
            },
            manually: {
                historical: false, //selección manual de ventas diario
                travel: false, //selección manual de ventas diario
                daily: false, //selección manual de ventas diario
                weekly: false, //selección manual de ventas semanal
                monthly: false, //selección manual de ventas mensual
                product: false, //selección manual de ventas por producto
                average: false, //selección manual de ventas por promedio
                service: false, //selección manual de ventas por servicio
            },
            checkboxes: [
                {
                    day: "Lunes",
                    char: "L",
                    value: true,
                    sales: ''
                },
                {
                    day: "Martes",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Miércoles",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Jueves",
                    char: "J",
                    value: true,
                    sales: ''
                },
                {
                    day: "Viernes",
                    char: "V",
                    value: true,
                    sales: ''
                },
                {
                    day: "Sábado",
                    char: "S",
                    value: true,
                    sales: ''
                },
                {
                    day: "Domingo",
                    char: "D",
                    value: true,
                    sales: ''
                },
            ],
            weeks: [
                {
                    week: '1',
                    sales: ''
                },
                {
                    week: '2',
                    sales: ''
                },
                {
                    week: '3',
                    sales: ''
                },
                {
                    week: '4',
                    sales: ''
                }
            ],
            months: [
                {
                    month: '1',
                    sales: ''
                },
                {
                    month: '2',
                    sales: ''
                },
                {
                    month: '3',
                    sales: ''
                }
            ],
            addProduct: false,
            editProduct: false,
            addService: false,
            editService: false,
            addVehicle: false,
            editVehicle: false,
            addRoute: false,
            editRoute: false,
            vehicles: [
                
            ],
            products: [
                
            ],
            services: [],
            productsItem: [],
            average: {
                periodicity: '',
                good_sale: '', //venta buena
                bad_sale: '', //venta mala
                regular_sale: '', //venta regular
                average_sales: '', //Promedio de ventas
                monthly_average_sales: '' //Promedio de ventas mensual
            },
            results: {
                daily: 0,
                weekly: 0,
                monthly: 0,
                product: 0,
                average: 0,
                service: 0,
                serviceTime: 0,
                total_average: 0
            },
            modelValidations: {
                sales: {
                    required: false
                },
                product_name: {
                    required: false,
                    max: 32
                },
                average_selection: {
                    required: false
                },
                route_name: {
                    required: false,
                    max: 30
                },
                item_name: {
                    required: false,
                    max: 64
                }
            },
        }
        },
        watch: {
            /**
             * This function processes historical data based on provided dates.
             * It resets and updates historical data if no sales data is populated in the store.
             * @param {Date} newDate - The new date to process.
             * @param {Date|null} oldDate - The old date to check for null.
             */
            historicalDate(newDate, oldDate) {
                const currentAssessment = this.$store.state.assesments[this.$store.state.actualAssesment];
                let currentCustomerStudy = null;
                if(this.$store.state.isCustomer){
                    currentCustomerStudy = currentAssessment.customer.studies[currentAssessment.customer.actualStudy];
                }
                else if(this.$store.state.isSpouse){
                    currentCustomerStudy = currentAssessment.customerSpouse.studies[currentAssessment.customerSpouse.actualStudy];
                }
                else if(this.$store.state.isGuarantor){
                    currentCustomerStudy = currentAssessment.guarantors[currentAssessment.actualGuarantors].studies[currentAssessment.guarantors[currentAssessment.actualGuarantors].actualStudy];
                }
                // Only proceed if there is no sales data populated in the current study
                if (!oldDate && currentCustomerStudy.salesPopulate) {
                    return; // No action needed, sales data already populated
                }
                
                // Reset and update historical month data
                this.resetHistoricalMonthData();
                const formattedDate = this.formatDateToMonth(newDate);
                this.updateHistoricalMonthData(formattedDate);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            minimumSalesVar : function (newVal, oldVal) {
                // console.info('ha cambiado la venta');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             'switches.historical': function (newVal, oldVal) {
                if (!newVal) {
                    this.historical = [];
                    this.historicalDate = null;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             'switches.travel': function (newVal, oldVal) {
                if (!newVal) {
                    this.vehicles = [];
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'switches.daily': function (newVal, oldVal) {
                if (!newVal) {
                    for (let i=0;i<this.checkboxes.length;i++) {
                        this.checkboxes[i].value = true;
                        this.checkboxes[i].sales = '';
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'switches.weekly': function (newVal, oldVal) {
                if (!newVal) {
                    for (let i=0;i<this.weeks.length;i++) {
                        this.weeks[i].sales = '';
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'switches.monthly': function (newVal, oldVal) {
                if (!newVal) {
                    for (let i=0;i<this.months.length;i++) {
                        this.months[i].sales = '';
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'switches.product': function (newVal, oldVal) {
                if (!newVal) {
                    this.products = []
                }
                else {
                    if(this.$store.state.productionCostsLocked) {
                        if (this.$store.state.isCustomer) {
                            if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem.length > 0) {
                                var productionItemsLocked = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem;
                                this.products = []
                                for (let i=0;i<productionItemsLocked.length; i++) {
                                    this.products.push({
                                        productName: productionItemsLocked[i].productName,
                                        productPeriodicity: productionItemsLocked[i].productPeriodicity,
                                        productSaleValue: productionItemsLocked[i].productSaleValue,
                                        productSaleMonthly: productionItemsLocked[i].productSaleMonthly,
                                        productMonth: productionItemsLocked[i].productMonth,
                                        productTotalSale: productionItemsLocked[i].productTotalSale,
                                        checkboxes: productionItemsLocked[i].checkboxes,
                                        weeks: productionItemsLocked[i].weeks,
                                        biweeks: productionItemsLocked[i].biweeks,
                                    })
                                }
                                this.costsChange = true;
                            }
                        }
                        else if (this.$store.state.isSpouse) {
                            if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem.length > 0) {
                                var productionItemsLocked = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem;
                                this.products = []
                                for (let i=0;i<productionItemsLocked.length; i++) {
                                    this.products.push({
                                        productName: productionItemsLocked[i].productName,
                                        productPeriodicity: productionItemsLocked[i].productPeriodicity,
                                        productSaleValue: productionItemsLocked[i].productSaleValue,
                                        productSaleMonthly: productionItemsLocked[i].productSaleMonthly,
                                        productMonth: productionItemsLocked[i].productMonth,
                                        productTotalSale: productionItemsLocked[i].productTotalSale,
                                        checkboxes: productionItemsLocked[i].checkboxes,
                                        weeks: productionItemsLocked[i].weeks,
                                        biweeks: productionItemsLocked[i].biweeks,
                                    })
                                }
                                this.costsChange = true;
                            }
                        }
                        else if(this.$store.state.isGuarantor) {
                            if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem.length > 0) {
                                var productionItemsLocked = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem;
                                this.products = []
                                for (let i=0;i<productionItemsLocked.length; i++) {
                                    this.products.push({
                                        productName: productionItemsLocked[i].productName,
                                        productPeriodicity: productionItemsLocked[i].productPeriodicity,
                                        productSaleValue: productionItemsLocked[i].productSaleValue,
                                        productSaleMonthly: productionItemsLocked[i].productSaleMonthly,
                                        productMonth: productionItemsLocked[i].productMonth,
                                        productTotalSale: productionItemsLocked[i].productTotalSale,
                                        checkboxes: productionItemsLocked[i].checkboxes,
                                        weeks: productionItemsLocked[i].weeks,
                                        biweeks: productionItemsLocked[i].biweeks,
                                    })
                                }
                                this.costsChange = true;
                            }
                        }
                    }
                    // else {
                    //     this.products = []
                    // }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'switches.average': function (newVal, oldVal) {
                if (!newVal) {
                    this.average = {
                        good_sale: '',
                        bad_sale: '',
                        regular_sale: '',
                        average_sales: '',
                        monthly_average_sales: ''
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'switches.service': function (newVal, oldVal) {
                if (!newVal) {
                    this.services = []
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             'manually.historical': function (newVal, oldVal) {
                if (newVal) {
                    this.minimumSalesVar = this.historical_sales_computed;
                    this.manually.daily = false;
                    this.manually.weekly = false;
                    this.manually.monthly = false;
                    this.manually.product = false;
                    this.manually.average = false;
                    this.manually.service = false;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             'manually.travel': function (newVal, oldVal) {
                if (newVal) {
                    this.minimumSalesVar = this.travel_sales_computed;
                    this.manually.historical = false;
                    this.manually.daily = false;
                    this.manually.weekly = false;
                    this.manually.monthly = false;
                    this.manually.product = false;
                    this.manually.average = false;
                    this.manually.service = false;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'manually.daily': function (newVal, oldVal) {
                if (newVal) {
                    this.minimumSalesVar = this.workdays_sales_computed;
                    this.manually.weekly = false;
                    this.manually.monthly = false;
                    this.manually.product = false;
                    this.manually.average = false;
                    this.manually.service = false;
                    this.manually.historical = false;
                    this.manually.travel = false;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'manually.weekly': function (newVal, oldVal) {
                if (newVal) {
                    this.minimumSalesVar = this.weekdays_sales_computed;
                    this.manually.daily = false;
                    this.manually.monthly = false;
                    this.manually.product = false;
                    this.manually.average = false;
                    this.manually.service = false;
                    this.manually.historical = false;
                    this.manually.travel = false;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'manually.monthly': function (newVal, oldVal) {
                if (newVal) {
                    this.minimumSalesVar = this.months_sales_computed;
                    this.manually.daily = false;
                    this.manually.weekly = false;
                    this.manually.product = false;
                    this.manually.average = false;
                    this.manually.service = false;
                    this.manually.historical = false;
                    this.manually.travel = false;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'manually.product': function (newVal, oldVal) {
                if (newVal) {
                    this.minimumSalesVar = this.products_sales_computed;
                    this.manually.daily = false;
                    this.manually.weekly = false;
                    this.manually.montlhy = false;
                    this.manually.average = false;
                    this.manually.service = false;
                    this.manually.historical = false;
                    this.manually.travel = false;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'manually.average': function (newVal, oldVal) {
                if (newVal) {
                    this.minimumSalesVar = this.average_monthly_sales_computed;
                    this.manually.daily = false;
                    this.manually.weekly = false;
                    this.manually.montlhy = false;
                    this.manually.product = false;
                    this.manually.service = false;
                    this.manually.historical = false;
                    this.manually.travel = false;
                }
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'manually.service': function (newVal, oldVal) {
                if (newVal) {
                    this.minimumSalesVar = this.services_sales_computed;
                    this.manually.daily = false;
                    this.manually.weekly = false;
                    this.manually.montlhy = false;
                    this.manually.product = false;
                    this.manually.average = false;
                    this.manually.historical = false;
                    this.manually.travel = false;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_sales_computed : function(val) {
                this.results.product = val;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            average_monthly_sales_computed : function(val) {
                this.results.total_average = val;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            average_sales_computed : function(val) {
                this.results.average = val;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdays_sales_computed : function(val) {
                this.results.daily = val;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            weekdays_sales_computed : function(val) {
                this.results.weekly = val;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            months_sales_computed : function(val) {
                this.results.monthly = val;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            services_sales_computed : function(val) {
                this.results.service = val;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            serviceTimeTotalComputed : function(val) {
                var sum = 0;
                for(let i=0; i<this.services.length;i++) {
                    sum = sum + this.services[i].serviceTimeTotal;
                }
                this.results.serviceTime = parseFloat(sum);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdays_computed: function (val) {
                if (this.switches.product && val > 0 && this.productDaily != 'NaN' && this.productDaily != '') {
                    this.productWeekly = parseFloat(val) * parseFloat(this.productDaily);
                }
                else if (val == 0) {
                    this.productWeekly = 0;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productDaily: function (val) {
                if (!this.switches.daily) {
                    this.productDailyCheckboxes = true;
                }
                else {
                    this.productDailyCheckboxes = false;
                }
                if (this.workdays_computed > 0 && val != 'NaN' && val != '') {
                    this.productWeekly = parseFloat(val) * this.workdays_computed;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            serviceDaily: function (val) {
                if (!this.switches.daily) {
                    this.serviceDailyCheckboxes = true;
                }
                else {
                    this.serviceDailyCheckboxes = false;
                }
                if (this.workdays_computed > 0 && val != 'NaN' && val != '') {
                    this.serviceWeekly = parseFloat(val) * this.workdays_computed;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productWeekly: function (val) {
                if (val != 'NaN' && val != '') {
                    this.productMonthly = parseFloat(val) * 4;
                }
                else if (val != 'NaN' && val == '') {
                    this.productMonthly = '';
                    this.productDaily = '';
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            serviceWeekly: function (val) {
                if (val != 'NaN' && val != '') {
                    this.serviceMonthly = parseFloat(val) * 4;
                }
                else if (val != 'NaN' && val == '') {
                    this.serviceMonthly = '';
                    this.serviceDaily = '';
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthly: function (val) {
                if (this.productValue != 0 && val != '') {
                    this.productMonthlyValue = parseFloat(val) * this.productValue;
                } 
                else {
                    this.productMonthlyValue = 0;
                }  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            serviceMonthly: function (val) {
                if (this.serviceValue != 0 && val != '') {
                    this.serviceMonthlyValue = parseFloat(val) * this.serviceValue;
                } 
                else {
                    this.serviceMonthlyValue = 0;
                }  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValue: function (val) {
                if (this.productMonthly != '' && this.productMonthly != 'NaN') {
                    this.productMonthlyValue = val * parseFloat(this.productMonthly);
                }
                else {
                    this.productMonthlyValue = 0;
                }
            }
        },
        computed: {
            travel_sales_computed() {
                // Asegúrate de que this.vehicles sea un array y que vehicleSales sea numérico
                return this.vehicles.reduce((total, vehicle) => {
                    const sales = parseFloat(vehicle.vehicleSales) || 0; // Si vehicleSales es null o undefined, usa 0
                    return total + sales;
                }, 0); // El valor inicial de la sumatoria es 0
            },
            // Calcula el valor del mes de la ruta
            calculatedRouteValue() {
                const quantity = this.routeQuantity || 0; // Asegúrate de que routeQuantity tenga un valor numérico
                const value = this.routeValue || 0; // Asegúrate de que routeValue tenga un valor numérico
                return quantity * value;
            },
             // Calcula la variación porcentual mes a mes
            computedHistoricalMonthData() {
                const data = [...this.historical];
                if (data.length < 2) return data; // No hay suficientes datos para calcular variación
                // Calcula la variación porcentual
                for (let i = 0; i < data.length; i++) {
                    const currentValue = parseFloat(data[i].inputValue) || 0;
                    if(i != data.length - 1) {
                        const previousValue = parseFloat(data[i + 1].inputValue) || 0;
                        const variation = previousValue !== 0 ? ((currentValue - previousValue) / previousValue) * 100 : null;
                        data[i].variation = variation !== null ? parseFloat(variation.toFixed(2)) : null;
                    }
                    // Calcula el valor IPC
                    data[i].ipcValue = currentValue * this.ipc;
                }        
                // El último mes (más antiguo) no tendrá variación
                data[data.length - 1].variation = null;
                return data;
            },
            // Calcula el promedio de ventas solo para los datos con checkbox seleccionado
            historical_sales_computed() {
                const checkedData = this.historical.filter(row => row.checked);
                const totalValue = checkedData.reduce((sum, row) => sum + (parseFloat(row.inputValue) || 0), 0);
                const count = checkedData.length;
                this.historicalAVG = count > 0 ? totalValue / count : 0;
                if(this.computedHistoricalMonthData.length > 0){
                    this.computedHistoricalMonthData[0].inputValue;
                    const previousValue = parseFloat(this.computedHistoricalMonthData[0].inputValue) || 0;
                    const variation = previousValue !== 0 ? ((this.historicalAVG - previousValue) / previousValue) * 100 : null;
                    this.historicalBaseMonth.value = parseFloat(this.historicalAVG.toFixed(2));
                    this.historicalBaseMonth.variation = variation !== null ? parseFloat(variation.toFixed(2)) : null;
                }
                return this.historicalAVG;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            costs_computed () {
                if (this.$store.state.isCustomer) {
                    var total = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalCost;
                }
                else if (this.$store.state.isSpouse) {
                    var total = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalCost;
                }
                else if(this.$store.state.isGuarantor) {
                    var total = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalCost;
                }
                var sum = 0;
                if (this.productsItem.length != 0) {
                    for (let i=0;i<this.productsItem.length;i++) {
                        if (this.productsItem.productCostPercent == 0 || this.productsItem.productPartPercent == 0) {
                            this.showNotificationError('Los productos del cruce por ítem no han sido completados. NO existen datos de % de participacion y % de costo de producto');
                        }
                        sum = sum + Math.round(this.final_minimum_sales_computed * (this.productsItem[i].productPartPercent / 100) * (this.productsItem[i].productCostPercent / 100));
                    }
                    total = sum;
                }
                if (sum != 0) {
                    this.$store.commit('setTotalCostsComputed',total);
                }
                if (this.$store.state.isCustomer) {
                    return this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].totalCost;
                }
                else if (this.$store.state.isSpouse) {
                    return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].totalCost;
                }
                else if(this.$store.state.isGuarantor) {
                    return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].totalCost;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            serviceTimeComputed () {
                if (this.servicePeriodicity == 'Diaria') {
                    var total = (Math.round(this.serviceSaleMonthly/4/this.serviceWorkdaysComputed * 100) / 100 ) * this.serviceTime;
                    this.serviceTimeTotal = total;
                    return this.timeConverter(total);
                }
                else {
                    var total = 0;
                    this.serviceTimeTotal = total;
                    return total;
                }
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            serviceTimeTotalComputed () {
                var sum = 0;
                for(let i=0; i<this.services.length;i++) {
                    sum = sum + this.services[i].serviceTimeTotal;
                }
                if (sum != 0) {
                    return this.timeConverter(sum);
                }
                else {
                    return 0
                }
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            monthlyServiceComputed () {
                var sum = 0;
                var total = 0;
                if (this.servicePeriodicity == 'Diaria') {
                    for (var i=0; i<this.serviceCheckboxesComputed.length; i++) {
                        if (this.serviceCheckboxesComputed[i].sales != '') {
                            sum = sum + parseFloat(this.serviceCheckboxesComputed[i].sales)
                            total = sum * 4
                        }
                    }
                }
                else if (this.servicePeriodicity == 'Semanal') {
                    for (var i=0; i<this.serviceWeeks.length; i++) {
                        if (this.serviceWeeks[i].sales != '') {
                            sum = sum + parseFloat(this.serviceWeeks[i].sales)
                            total = sum
                        }
                    }
                }
                else if (this.servicePeriodicity == 'Quincenal') {
                    for (var i=0; i<this.serviceBiweeks.length; i++) {
                        if (this.serviceBiweeks[i].sales != '') {
                            sum = sum + parseFloat(this.serviceBiweeks[i].sales)
                            total = sum
                        }
                    }
                }
                else if (this.servicePeriodicity == 'Mensual') {
                    total = this.serviceMonth;
                }
                this.serviceSaleMonthly = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            monthlyAverageComputed () {
                var sum = 0;
                var total = 0;
                if (this.productPeriodicity == 'Diaria') {
                    for (var i=0; i<this.productCheckboxesComputed.length; i++) {
                        if (this.productCheckboxesComputed[i].sales != '') {
                            sum = sum + parseFloat(this.productCheckboxesComputed[i].sales)
                            total = sum * 4
                        }
                    }
                }
                else if (this.productPeriodicity == 'Semanal') {
                    for (var i=0; i<this.productWeeks.length; i++) {
                        if (this.productWeeks[i].sales != '') {
                            sum = sum + parseFloat(this.productWeeks[i].sales)
                            total = sum
                        }
                    }
                }
                else if (this.productPeriodicity == 'Quincenal') {
                    for (var i=0; i<this.productBiweeks.length; i++) {
                        if (this.productBiweeks[i].sales != '') {
                            sum = sum + parseFloat(this.productBiweeks[i].sales)
                            total = sum
                        }
                    }
                }
                else if (this.productPeriodicity == 'Mensual') {
                    total = this.productMonth;
                }
                this.productSaleMonthly = total;
                return total;
            },
            routesAverageComputed (){
                var sum = 0;
                var total = 0;
                if (this.routePeriodicity == 'Diaria') {
                    for (var i=0; i<this.routeCheckboxesComputed.length; i++) {
                        if (this.routeCheckboxesComputed[i].sales != '') {
                            sum = sum + parseFloat(this.routeCheckboxesComputed[i].sales)
                            total = sum * 4
                        }
                    }
                }
                else if (this.routePeriodicity == 'Semanal') {
                    for (var i=0; i<this.routeWeeks.length; i++) {
                        if (this.routeWeeks[i].sales != '') {
                            sum = sum + parseFloat(this.routeWeeks[i].sales)
                            total = sum
                        }
                    }
                }
                else if (this.routePeriodicity == 'Mensual') {
                    total = parseFloat(this.routeMonth || 0);
                }
                this.routeQuantity = total;
                return parseInt(total);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            serviceCheckboxesComputed () {
                return this.serviceCheckboxes.filter(day => day.value == true);
            },
            routeCheckboxesComputed () {
                return this.routeCheckboxes.filter(day => day.value == true);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            serviceWorkdaysComputed () {
                return this.serviceCheckboxes.filter(day => day.value == true).length;
            },
            routesWorkdaysComputed () {
                return this.routeCheckboxes.filter(day => day.value == true).length;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCheckboxesComputed () {
                return this.productCheckboxes.filter(day => day.value == true);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productWorkdaysComputed () {
                return this.productCheckboxes.filter(day => day.value == true).length;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productTotalSaleComputed () {
                var total = this.productSaleMonthly * this.productSaleValue;
                this.productTotalSale = total;
                return total;

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            serviceTotalSaleComputed () {
                var total = this.serviceSaleMonthly * this.serviceSaleValue;
                this.serviceTotalSale = total;
                return total;

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            final_minimum_sales_computed: {
                get: function () {
                    var minimumSales = this.minimumSalesVar;
                    if (minimumSales != 0) {
                        if (minimumSales == this.workdays_sales_computed || minimumSales == this.weekdays_sales_computed || minimumSales == this.months_sales_computed || minimumSales == this.products_sales_computed || minimumSales == this.average_monthly_sales_computed || minimumSales == this.services_sales_computed || minimumSales == this.historical_sales_computed || minimumSales == this.travel_sales_computed) {
                            if (minimumSales == this.workdays_sales_computed) {
                                this.manually.daily = true;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.weekdays_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = true;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.months_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = true;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.products_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = true;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.average_monthly_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            
                            }
                            else if (minimumSales == this.services_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = true;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.historical_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = true;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.travel_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = true;
                            }
                            return minimumSales;
                        }
                        else {
                            minimumSales = this.minimum_sales_computed;
                            if (minimumSales == this.workdays_sales_computed) {
                                this.manually.daily = true;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.weekdays_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = true;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.months_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = true;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.products_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = true;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.average_monthly_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = true;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            
                            }
                            else if (minimumSales == this.services_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = true;
                                this.manually.historical = false;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.historical_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = true;
                                this.manually.travel = false;
                            }
                            else if (minimumSales == this.travel_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = true;
                            }
                            return this.minimum_sales_computed;
                        }
                    } 
                    else {
                        minimumSales = this.minimum_sales_computed;
                        if (minimumSales == this.workdays_sales_computed) {
                            this.manually.daily = true;
                            this.manually.weekly = false;
                            this.manually.monthly = false;
                            this.manually.product = false;
                            this.manually.average = false;
                            this.manually.service = false;
                            this.manually.historical = false;
                            this.manually.travel = false;
                        }
                        else if (minimumSales == this.weekdays_sales_computed) {
                            this.manually.daily = false;
                            this.manually.weekly = true;
                            this.manually.monthly = false;
                            this.manually.product = false;
                            this.manually.average = false;
                            this.manually.service = false;
                            this.manually.historical = false;
                            this.manually.travel = false;
                        }
                        else if (minimumSales == this.months_sales_computed) {
                            this.manually.daily = false;
                            this.manually.weekly = false;
                            this.manually.monthly = true;
                            this.manually.product = false;
                            this.manually.average = false;
                            this.manually.service = false;
                            this.manually.historical = false;
                            this.manually.travel = false;
                        }
                        else if (minimumSales == this.products_sales_computed) {
                            this.manually.daily = false;
                            this.manually.weekly = false;
                            this.manually.monthly = false;
                            this.manually.product = true;
                            this.manually.average = false;
                            this.manually.service = false;
                            this.manually.historical = false;
                            this.manually.travel = false;
                        }
                        else if (minimumSales == this.average_sales_computed) {
                            this.manually.daily = false;
                            this.manually.weekly = false;
                            this.manually.monthly = false;
                            this.manually.product = false;
                            this.manually.average = true;
                            this.manually.service = false;
                            this.manually.historical = false;
                            this.manually.travel = false;
                        }
                        else if (minimumSales == this.services_sales_computed) {
                            this.manually.daily = false;
                            this.manually.weekly = false;
                            this.manually.monthly = false;
                            this.manually.product = false;
                            this.manually.average = false;
                            this.manually.service = true;
                            this.manually.historical = false;
                            this.manually.travel = false;
                        }
                        else if (minimumSales == this.historical_sales_computed) {
                            this.manually.daily = false;
                            this.manually.weekly = false;
                            this.manually.monthly = false;
                            this.manually.product = false;
                            this.manually.average = false;
                            this.manually.historical = true;
                            this.manually.travel = false;
                        }
                        else if (minimumSales == this.travel_sales_computed) {
                                this.manually.daily = false;
                                this.manually.weekly = false;
                                this.manually.monthly = false;
                                this.manually.product = false;
                                this.manually.average = false;
                                this.manually.service = false;
                                this.manually.historical = false;
                                this.manually.travel = true;
                            }
                    }
                    return minimumSales;
                },
                set: function (val) {
                    this.minimumSalesVar = val;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            minimum_sales_computed () {
                var arrayComputed = [this.workdays_sales_computed,this.weekdays_sales_computed,this.months_sales_computed,this.products_sales_computed,this.average_monthly_sales_computed, this.historical_sales_computed, this.travel_sales_computed];
                var   arrayFinalComputed = [];
                for(let i=0;i<arrayComputed.length;i++){
                    if(arrayComputed[i] != 0) {
                        arrayFinalComputed.push(
                            arrayComputed[i]
                        )
                    }
                }
                if(arrayFinalComputed.length != 0) {
                    const minimumSales = Math.min(...arrayFinalComputed);
                    return minimumSales    
                }
                else {
                    return 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_sales_computed () {
                var sum = 0;
                if (this.products) {
                    for (var i=0;i<this.products.length;i++) {
                        sum = sum + parseFloat(this.products[i].productTotalSale);
                    }
                }
                return sum;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            services_sales_computed () {
                var sum = 0;
                if (this.services) {
                    for (var i=0;i<this.services.length;i++) {
                        sum = sum + parseFloat(this.services[i].serviceTotalSale);
                    }
                }
                return sum;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            average_sales_computed () {
                return Math.round((this.average.good_sale + this.average.regular_sale + this.average.bad_sale) / 3);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            average_monthly_sales_computed () {
                var sum = 0;
                var total = 0;
                if (this.average.periodicity == 'Diaria') {
                    return this.average_sales_computed * this.workdays_computed * 4;
                }
                else if (this.average.periodicity == 'Semanal') {
                    return this.average_sales_computed * 4;
                }
                else if (this.average.periodicity == 'Mensual') {
                    return this.average_sales_computed;
                }
                else {
                    return 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdays_computed () {
                return this.checkboxes.filter(day => day.value == true).length;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            checkboxes_computed () {
                return this.checkboxes.filter(day => day.value == true);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdays_sales_computed () {
                var sum = 0;
                var total = 0;
                for (var i=0; i<this.checkboxes_computed.length; i++) {
                    if (this.checkboxes_computed[i].sales != '') {
                        sum = sum + parseFloat(this.checkboxes_computed[i].sales)
                        total = sum * 4
                    }
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            weekdays_sales_computed () {
                var sum = 0;
                var total = 0;
                for (var i=0; i<this.weeks.length; i++) {
                    if (this.weeks[i].sales != '') {
                        sum = sum + parseFloat(this.weeks[i].sales)
                        total = sum
                    }
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            months_sales_computed () {
                var sum = 0;
                var avg = 0;
                for (var i=0; i<this.months.length; i++) {
                    if (this.months[i].sales != '') {
                        sum = sum + parseFloat(this.months[i].sales)
                        avg = sum / this.months.length
                    }
                }
                return avg;
            },
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             setPymeSalesDescription (description) {
                this.pymeMessage = description;
                this.$store.commit('updateCustomerPESales', description)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveSalesPymeData (description) {
                this.setPymeSalesDescription(description);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            openFCIMethod(){
                this.openFCI = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelOpenFCI(){ 
                this.openFCI = false;
            },
            resetRoutePeriodicity () {
                this.routeCheckboxes= [
                {
                    day: "Lunes",
                    char: "L",
                    value: true,
                    sales: ''
                },
                {
                    day: "Martes",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Miércoles",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Jueves",
                    char: "J",
                    value: true,
                    sales: ''
                },
                {
                    day: "Viernes",
                    char: "V",
                    value: true,
                    sales: ''
                },
                {
                    day: "Sábado",
                    char: "S",
                    value: true,
                    sales: ''
                },
                {
                    day: "Domingo",
                    char: "D",
                    value: true,
                    sales: ''
                },
            ];
            this.routeWeeks= [
                {
                    week: '1',
                    sales: ''
                },
                {
                    week: '2',
                    sales: ''
                },
                {
                    week: '3',
                    sales: ''
                },
                {
                    week: '4',
                    sales: ''
                }
            ];
            this.routeMonth = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            initializeRoutes () {
                if (this.pyme) {
                    this.routes.general = '/asessments/new_asessment/customer/pyme_general_costs_selection';
                    this.routes.produccion = '/asessments/new_asessment/customer/costs/business/pyme/produccion';
                    this.routes.transporte = '/asessments/new_asessment/customer/costs/services/pyme-transport';
                } else {
                    this.routes.general = '/asessments/new_asessment/customer/costs/business/general';
                    this.routes.produccion = '/asessments/new_asessment/customer/costs/business/produccion';
                    this.routes.transporte = '/asessments/new_asessment/customer/costs/services/transport';
                    
                }
                this.routes.serviciogeneral = '/asessments/new_asessment/customer/costs/business/serviciogeneral';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addRouteToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.routeName == '' || this.routeValue == 0 || this.routePeriodicity == '' || this.routeProduct == '' || this.routeQuantity == null) {
                            this.showNotificationError('Todos los campos de la ruta deben ser diligenciados');
                        }
                        else {
                            
                            this.vehicles[this.addRouteIndex].routes.push({
                                routeName: this.routeName,
                                routePeriodicity: this.routePeriodicity,
                                routeQuantity: this.routeQuantity,
                                routeValue: this.routeValue,
                                routeProduct: this.routeProduct,
                                routeTotal: this.calculatedRouteValue,
                                routeCheckboxes: this.routeCheckboxes,
                                routeWeeks: this.routeWeeks,
                                routeMonth: this.routeMonth
                            })
                            var routeSum = 0;
                            for (let i=0; i<this.vehicles[this.addRouteIndex].routes.length;i++) {
                                routeSum = routeSum + this.vehicles[this.addRouteIndex].routes[i].routeTotal;
                            }
                            this.vehicles[this.addRouteIndex].vehicleSales = routeSum;
                            this.resetRoute();
                            this.addRoute = false;
                            this.addRouteIndex = null;
                            this.showNotificationSuccess('Ruta agregada correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editRouteToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.routeName == '' || this.routeValue == 0 || this.routePeriodicity == '' || this.routeProduct == '' || this.routeQuantity == null) {
                            this.showNotificationError('Todos los campos de la ruta deben ser diligenciados');
                        }
                        else {
                            
                            
                            this.vehicles[this.editRouteIndex].routes[this.vehicles[this.editRouteIndex].routes.indexOf(this.currentRouteRow)].routeName = this.routeName,
                            this.vehicles[this.editRouteIndex].routes[this.vehicles[this.editRouteIndex].routes.indexOf(this.currentRouteRow)].routePeriodicity = this.routePeriodicity,
                            this.vehicles[this.editRouteIndex].routes[this.vehicles[this.editRouteIndex].routes.indexOf(this.currentRouteRow)].routeQuantity = this.routeQuantity,
                            this.vehicles[this.editRouteIndex].routes[this.vehicles[this.editRouteIndex].routes.indexOf(this.currentRouteRow)].routeValue = this.routeValue,
                            this.vehicles[this.editRouteIndex].routes[this.vehicles[this.editRouteIndex].routes.indexOf(this.currentRouteRow)].routeProduct = this.routeProduct,
                            this.vehicles[this.editRouteIndex].routes[this.vehicles[this.editRouteIndex].routes.indexOf(this.currentRouteRow)].routeTotal = this.calculatedRouteValue,
                            this.vehicles[this.editRouteIndex].routes[this.vehicles[this.editRouteIndex].routes.indexOf(this.currentRouteRow)].routeCheckboxes = this.routeCheckboxes,
                            this.vehicles[this.editRouteIndex].routes[this.vehicles[this.editRouteIndex].routes.indexOf(this.currentRouteRow)].routeWeeks = this.routeWeeks,
                            this.vehicles[this.editRouteIndex].routes[this.vehicles[this.editRouteIndex].routes.indexOf(this.currentRouteRow)].routeMonth = this.routeMonth
                            
                            var routeSum = 0;
                            for (let i=0; i<this.vehicles[this.editRouteIndex].routes.length;i++) {
                                routeSum = routeSum + this.vehicles[this.editRouteIndex].routes[i].routeTotal;
                            }
                            this.vehicles[this.editRouteIndex].vehicleSales = routeSum;
                            this.resetRoute();
                            this.editRoute = false;
                            this.editRouteIndex = null;
                            this.showNotificationSuccess('Ruta editada correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetRoute () {
                this.routeName = '',
                this.routePeriodicity = '',
                this.routeQuantity = null,
                this.routeValue = ''
                this.routeProduct = ''
                this.resetRoutePeriodicity();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeRoute (row) {
                this.vehicles[row].routes.splice(this.vehicles[row].routes.indexOf(this.currentRouteRow),1);
                var routeSum = 0;
                for (let i=0; i<this.vehicles[row].routes.length;i++) {
                    routeSum = routeSum + this.vehicles[row].routes[i].routeValue;
                }
                this.vehicles[row].vehicleSales = routeSum;
                this.currentRouteRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addRouteMethod (row) {
                this.resetRoute();
                this.addRouteIndex = row;
                this.addRoute = true;
            },
            editRouteMethod (row) {
                this.editRouteIndex = row;
                this.routeName = this.vehicles[row].routes[this.vehicles[row].routes.indexOf(this.currentRouteRow)].routeName;
                this.routePeriodicity = this.vehicles[row].routes[this.vehicles[row].routes.indexOf(this.currentRouteRow)].routePeriodicity;
                this.routeQuantity = this.vehicles[row].routes[this.vehicles[row].routes.indexOf(this.currentRouteRow)].routeQuantity;
                this.routeValue = this.vehicles[row].routes[this.vehicles[row].routes.indexOf(this.currentRouteRow)].routeValue;
                this.routeProduct = this.vehicles[row].routes[this.vehicles[row].routes.indexOf(this.currentRouteRow)].routeProduct;
                this.routeCheckboxes = this.vehicles[row].routes[this.vehicles[row].routes.indexOf(this.currentRouteRow)].routeCheckboxes;
                this.routeWeeks = this.vehicles[row].routes[this.vehicles[row].routes.indexOf(this.currentRouteRow)].routeWeeks;
                this.routeMonth = this.vehicles[row].routes[this.vehicles[row].routes.indexOf(this.currentRouteRow)].routeMonth;
                this.editRoute = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddRoute () {
                this.addRoute = false;
                this.resetRoute();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditRoute () {
                this.editRoute = false;
                this.resetRoute();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditVehicle () {
                this.editVehicle = false;
                this.resetVehicle();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleCurrentRouteChange(currentRow, oldCurrentRow) {
                this.currentRouteRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetHistoricalMonthData() {
                // Resetea el array de historical
                this.historical = [];
            },
            projectedSalesModal(){
            // Inicializa el array para datos proyectados
            this.projectedSalesHistoricalMonthData = this.historical.map((data) => {
                let projectedValue;
                try {
                // Calcula el valor proyectado
                projectedValue = parseFloat(data.inputValue) * this.ipc;
                if (isNaN(projectedValue)) {
                    throw new Error('Invalid input value'); // Lanza un error si el valor es NaN
                }
                } catch (error) {
                // Maneja errores y establece el valor proyectado en 0
                projectedValue = 0;
                }
                
                // Retorna el nuevo objeto con label y valor proyectado
                return {
                    label: data.label_projection,
                    value: this.setFormat(projectedValue.toFixed(2)), // Formatea a dos decimales
                };
            });
            this.modalProjectedSales = true;
            },
            getVariationClass(variation) {
                if (variation === null) return '';
                return variation >= 50 || variation <= -50 ? 'highlight-orange' : '';
            },
            formatDateToMonth(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                return `${year}-${month}`;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            updateHistoricalMonthData(date) {
            try {
                const [year, month] = date.split('-').map(Number);
                const startDate = new Date(year, month - 1); // Meses son 0-indexados en JavaScript
                const historicalData = [];

                for (let i = 0; i < 12; i++) {
                const currentMonth = new Date(startDate);
                currentMonth.setMonth(startDate.getMonth() - i);
                const label = `${this.getMonthName(currentMonth.getMonth())} ${currentMonth.getFullYear()}`;
                // Proyectar el mismo mes pero con el año siguiente
                const projectionYear = currentMonth.getFullYear() + 1;
                const label_projection = `${this.getMonthName(currentMonth.getMonth())} ${projectionYear}`;
                historicalData.push({
                    label: label,
                    label_projection: label_projection,
                    inputValue: '',
                    variation: null,
                    checked: true
                });
                }
                this.historical = historicalData; // Ordenar del mes actual al más antiguo
                if(this.final_minimum_sales_computed != 0) {
                    this.historical[0].inputValue = this.final_minimum_sales_computed;
                }
            } catch (error) {
                console.error('Error al actualizar los datos históricos:', error);
            }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getMonthName(monthIndex) {
                const months = [
                    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ];
                return months[monthIndex];
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            timeConverter(n) {
                var num = n;
                var hours = (num / 60);
                var rhours = Math.floor(hours);
                var minutes = (hours - rhours) * 60;
                var rminutes = Math.round(minutes);
                return rhours + " hora(s) y " + rminutes + " minuto(s).";
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyCostsLocked() {
                if (this.$store.state.productionCostsLocked) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addServiceToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.serviceName == '' || this.serviceTotalSale == 0) {
                            this.showNotificationError('El campo nombre de serviceo y total no pueden estar vacíos');
                        }
                        else {
                            this.services.push({
                                serviceName: this.serviceName,
                                servicePeriodicity: this.servicePeriodicity,
                                serviceMonth: this.serviceMonth,
                                serviceSaleValue: this.serviceSaleValue,
                                serviceSaleMonthly: this.serviceSaleMonthly,
                                serviceTotalSale: this.serviceTotalSale,
                                serviceTime: this.serviceTime,
                                serviceTimeTotal: this.serviceTimeTotal,
                                checkboxes: this.serviceCheckboxes,
                                weeks: this.serviceWeeks,
                                biweeks: this.serviceBiweeks,
                            })
                            this.resetService();
                            this.addService = false;
                            this.showNotificationSuccess('Ítem de cantidad agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addVehicleToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.vehicleName == '') {
                            this.showNotificationError('El campo nombre de vehículo no puede estar vacío');
                        }
                        else {
                            this.vehicles.push({
                                vehicleName: this.vehicleName,
                                vehicleSales: 0,
                                routes: []
                            })
                            this.resetVehicle();
                            this.addVehicle = false;
                            this.showNotificationSuccess('Vehículo agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editVehicleToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.vehicleName == '') {
                            this.showNotificationError('El campo nombre de vehículo no puede estar vacío');
                        }
                        else {
                            this.vehicles[this.vehicles.indexOf(this.currentRow)].vehicleName = this.vehicleName;
                            this.resetVehicle();
                            this.editVehicle = false;
                            this.showNotificationSuccess('Vehículo editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName == '' || this.productTotalSale == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            this.products.push({
                                productName: this.productName,
                                productPeriodicity: this.productPeriodicity,
                                productSaleValue: this.productSaleValue,
                                productMonth: this.productMonth,
                                productSaleMonthly: this.productSaleMonthly,
                                productTotalSale: this.productTotalSale,
                                checkboxes: this.productCheckboxes,
                                weeks: this.productWeeks,
                                biweeks: this.productBiweeks,
                                productCostPercent: 0,
                                productUnitCosting: 0,
                                productSalesCosting: 0,
                                productTotalCosting: 0,
                                productTotalCost: 0,
                                productUnitCost: 0,
                            })
                            this.resetProduct();
                            this.addProduct = false;
                            this.showNotificationSuccess('Producto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName == '' || this.productTotalSale == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].productName = this.productName;
                            this.products[index].productPeriodicity = this.productPeriodicity;
                            this.products[index].productSaleValue = this.productSaleValue;
                            this.products[index].productSaleMonthly = this.productSaleMonthly;
                            this.products[index].productMonth = this.productMonth;
                            this.products[index].productTotalSale = this.productTotalSale;
                            this.products[index].checkboxes = this.productCheckboxes;
                            this.products[index].weeks = this.productWeeks;
                            this.products[index].biweeks = this.productBiweeks;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.showNotificationSuccess('Producto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editServiceToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.serviceName == '' || this.serviceTotalSale == 0) {
                            this.showNotificationError('El campo nombre de serviceo y total no pueden estar vacíos');
                        }
                        else {
                            var index = this.services.indexOf(this.currentRow);
                            this.services[index].serviceName = this.serviceName;
                            this.services[index].servicePeriodicity = this.servicePeriodicity;
                            this.services[index].serviceSaleValue = this.serviceSaleValue;
                            this.services[index].serviceSaleMonthly = this.serviceSaleMonthly;
                            this.services[index].serviceMonth = this.serviceMonth;
                            this.services[index].serviceTotalSale = this.serviceTotalSale;
                            this.services[index].serviceTime = this.serviceTime;
                            this.services[index].serviceTimeTotal = this.serviceTimeTotal;
                            this.services[index].checkboxes = this.serviceCheckboxes;
                            this.services[index].weeks = this.serviceWeeks;
                            this.services[index].biweeks = this.serviceBiweeks;
                            this.resetService();
                            this.currentRow = null;
                            this.$refs.servicesTable.setCurrentRow();
                            this.editService = false;
                            this.showNotificationSuccess('Servicio editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetService () {
                this.serviceName= '';
                this.serviceSaleValue= '';
                this.servicePeriodicity= '';
                this.serviceMonth= '';
                this.serviceTime= '';
                this.serviceTimeTotal= '';
                this.serviceSaleMonthly= '';
                this.serviceTotalSale= '';
                this.serviceCheckboxes= [
                {
                    day: "Lunes",
                    char: "L",
                    value: true,
                    sales: ''
                },
                {
                    day: "Martes",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Miércoles",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Jueves",
                    char: "J",
                    value: true,
                    sales: ''
                },
                {
                    day: "Viernes",
                    char: "V",
                    value: true,
                    sales: ''
                },
                {
                    day: "Sábado",
                    char: "S",
                    value: true,
                    sales: ''
                },
                {
                    day: "Domingo",
                    char: "D",
                    value: true,
                    sales: ''
                },
            ]
            this.serviceWeeks= [
                {
                    week: '1',
                    sales: ''
                },
                {
                    week: '2',
                    sales: ''
                },
                {
                    week: '3',
                    sales: ''
                },
                {
                    week: '4',
                    sales: ''
                }
            ]
            this.serviceBiweeks= [
                {
                    biweek: '1',
                    sales: ''
                },
                {
                    biweek: '2',
                    sales: ''
                }
            ]
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetVehicle () {
                this.vehicleName = '';
                this.vehicleSales = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.productName= '';
                this.productSaleValue= '';
                this.productPeriodicity= '';
                this.productMonth= '';
                this.productSaleMonthly= '';
                this.productTotalSale= '';
                this.productCheckboxes= [
                {
                    day: "Lunes",
                    char: "L",
                    value: true,
                    sales: ''
                },
                {
                    day: "Martes",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Miércoles",
                    char: "M",
                    value: true,
                    sales: ''
                },
                {
                    day: "Jueves",
                    char: "J",
                    value: true,
                    sales: ''
                },
                {
                    day: "Viernes",
                    char: "V",
                    value: true,
                    sales: ''
                },
                {
                    day: "Sábado",
                    char: "S",
                    value: true,
                    sales: ''
                },
                {
                    day: "Domingo",
                    char: "D",
                    value: true,
                    sales: ''
                },
            ]
            this.productWeeks= [
                {
                    week: '1',
                    sales: ''
                },
                {
                    week: '2',
                    sales: ''
                },
                {
                    week: '3',
                    sales: ''
                },
                {
                    week: '4',
                    sales: ''
                }
            ]
            this.productBiweeks= [
                {
                    biweek: '1',
                    sales: ''
                },
                {
                    biweek: '2',
                    sales: ''
                }
            ]
            },
            getRandomNumber() {
            return Math.floor(Math.random() * 5) + 1;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelModalProjectedSales() {
                this.modalProjectedSales = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelPymeChartModalViewer() {
                this.pymeChartModal = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addServiceMethod () {
                this.addService = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editServiceMethod () {
                this.serviceName= this.currentRow.serviceName;
                this.servicePeriodicity = this.currentRow.servicePeriodicity;
                this.serviceMonth = this.currentRow.serviceMonth;
                this.serviceTime = this.currentRow.serviceTime;
                this.serviceSaleValue= this.currentRow.serviceSaleValue;
                this.serviceSaleMonthly= this.currentRow.serviceSaleMonthly;
                this.serviceSelect= this.currentRow.serviceSelect;
                this.serviceMultiplier= this.currentRow.serviceMultiplier;
                this.serviceCheckboxes= this.currentRow.checkboxes;
                this.serviceWeeks= this.currentRow.weeks;
                this.serviceBiweeks= this.currentRow.biweeks;
                this.editService = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeServiceMethod () {
                this.services.splice(this.services.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.productName= this.currentRow.productName;
                this.productPeriodicity = this.currentRow.productPeriodicity;
                this.productMonth = this.currentRow.productMonth;
                this.productSaleValue= this.currentRow.productSaleValue;
                this.productSaleMonthly= this.currentRow.productSaleMonthly;
                this.productSelect= this.currentRow.productSelect;
                this.productMultiplier= this.currentRow.productMultiplier;
                this.productCheckboxes= this.currentRow.checkboxes;
                this.productWeeks= this.currentRow.weeks;
                this.productBiweeks= this.currentRow.biweeks;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addVehicleMethod () {
                this.addVehicle = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editVehicleMethod () {
                this.vehicleName = this.currentRow.vehicleName;
                this.editVehicle = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeVehicleMethod () {
                this.vehicles.splice(this.vehicles.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddService () {
                this.addService = false;
                this.resetService();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditService () {
                this.editService = false;
                this.resetService();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddVehicle () {
                this.addVehicle = false;
                this.resetVehicle();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editVehicle = false;
                this.resetVehicle();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            dailySelectValidation () {
                if (this.checkboxes.filter(day => day.value == true).length) {
                    return false
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addMonth () {
                this.months.push({
                    month: String(this.months.length + 1),
                    sales: ''
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeMonth () {
                this.months.splice(this.months.length-1,1);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateSwitch () {
                if(this.switches.historical || this.switches.travel || this.switches.daily || this.switches.weekly || this.switches.monthly || this.switches.product || this.switches.average || this.switches.service) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            confirmSales () {
                if (this.switches.historical == true && this.historical_sales_computed == 0) {
                    this.showNotificationError('El cruce de ventas histórico ha sido seleccionado, pero su valor es 0');
                    return   
                }
                if (this.switches.travel == true && this.travel_sales_computed == 0) {
                    this.showNotificationError('El cruce de ventas histórico ha sido seleccionado, pero su valor es 0');
                    return   
                }
                if (this.switches.daily == true && this.workdays_sales_computed == 0) {
                    this.showNotificationError('El cruce de ventas diario ha sido seleccionado, pero su valor es 0');
                    return   
                }
                if (this.switches.weekly == true && this.weekdays_sales_computed == 0) {
                    this.showNotificationError('El cruce de ventas semanal ha sido seleccionado, pero su valor es 0');
                    return
                }
                if (this.switches.monthly == true && this.months_sales_computed == 0) {
                    this.showNotificationError('El cruce de ventas mensual ha sido seleccionado, pero su valor es 0');
                    return
                }
                if (this.switches.product == true && this.products_sales_computed == 0) {
                    this.showNotificationError('El cruce de ventas por producto ha sido seleccionado, pero su valor es 0');
                    return
                }
                if (this.switches.average == true && this.average_monthly_sales_computed == 0) {
                    this.showNotificationError('El cruce de ventas por promedio ha sido seleccionado, pero su valor es 0');
                    return
                }
                if (this.switches.service == true && this.services_sales_computed == 0) {
                    this.showNotificationError('El cruce de ventas de cantidad ha sido seleccionado, pero su valor es 0');
                    return
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            confirmData () {
                var callback =  {
                    boolean: false,
                    message: ''
                }
                var countFlag = 0;
                if(this.switches.historical == true && this.historical_sales_computed != 0) {
                    countFlag = countFlag + 1;
                }
                if(this.switches.travel == true && this.travel_sales_computed != 0) {
                    countFlag = countFlag + 1;
                }
                if(this.switches.daily == true && this.workdays_sales_computed != 0) {
                    countFlag = countFlag + 1;
                }
                if(this.switches.weekly == true && this.weekdays_sales_computed != 0) {
                    countFlag = countFlag + 1;
                }
                if(this.switches.monthly == true && this.months_sales_computed != 0) {
                    countFlag = countFlag + 1;
                }
                if(this.switches.product == true && this.products_sales_computed != 0) {
                    countFlag = countFlag + 1;
                }
                if(this.switches.average == true && this.average_monthly_sales_computed != 0) {
                    countFlag = countFlag + 1;
                }
                if(this.switches.service == true && this.services_sales_computed != 0) {
                    countFlag = countFlag + 1;
                }
                if (countFlag < 3) {
                    callback.boolean = true;
                    if (callback.message == '') {
                        callback.message = "Es necesario realizar al menos 3 cruces de ventas"    
                    }
                    else {
                        callback.message = callback.message +  
                        " | Es necesario realizar al menos 3 cruces de ventas"
                    }
                }
                return callback
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveSales () {
                if(this.pyme && !this.switches.historical && this.historical_sales_computed == 0){
                    this.switches.historical = true;
                    this.showNotificationError('Debe diligenciar el Histórico Mes Base para finalizar los cruces de ventas');
                    return   
                }
                if (this.$store.state.isCustomer) {
                    if (this.switches.historical == true && this.historical_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas mes base ha sido seleccionado, pero su valor es 0');
                        return   
                    }
                    if (this.switches.travel == true && this.travel_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas por viaje ha sido seleccionado, pero su valor es 0');
                        return   
                    }
                    if (this.switches.daily == true && this.workdays_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas diario ha sido seleccionado, pero su valor es 0');
                        return   
                    }
                    if (this.switches.weekly == true && this.weekdays_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas semanal ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.monthly == true && this.months_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas mensual ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.product == true && this.products_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas por producto ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.average == true && this.average_monthly_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas por promedio ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.service == true && this.services_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas de cantidad ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    var callback = this.confirmData();
                    if (callback.boolean == false) {
                        this.$store.dispatch('setSalesData', this.$data).then(()=>{
                            var arrayComputed = [this.workdays_sales_computed,this.weekdays_sales_computed,this.months_sales_computed,this.products_sales_computed,this.average_monthly_sales_computed,this.historical_sales_computed,this.travel_sales_computed];
                            var   arrayFinalComputed = [];
                            for(let i=0;i<arrayComputed.length;i++){
                                if(arrayComputed[i] != 0) {
                                    arrayFinalComputed.push(
                                        arrayComputed[i]
                                    )
                                }
                            }
                            const minimumSales = Math.min(...arrayFinalComputed);
                            if (this.final_minimum_sales_computed != this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem.length > 0) {
                                this.costsChange = true;
                            }
                            // this.$store.dispatch('setSalesDataComputed', minimumSales).then(()=>{
                            this.$store.dispatch('setSalesDataComputed', this.final_minimum_sales_computed).then(()=>{
                                this.$store.dispatch('setSalesDataPopulate', true).then(()=>{
                                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate == false) {
                                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                        var payload = {
                                            stage: 'Ingreso de datos de negocio',
                                            description: 'Se ingresan los cruces de ventas.',
                                            dateTime: moment().format()
                                        };
                                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (subcategory == 'general') {
                                                this.$router.push(this.routes.general);
                                            }
                                            else if (subcategory == 'produccion') {
                                                this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                                            }
                                            else if (subcategory == 'transporte') {
                                                this.$router.push(this.routes.transporte);
                                            }
                                            else if (subcategory == 'serviciogeneral') {
                                                this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                            }
                                        }).catch((error) => {
                                            this.showNotificationError('Error escribiendo el log')
                                        });
                                    }
                                    else {
                                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                        var payload = {
                                            stage: 'Ingreso de datos de negocio',
                                            description: 'Se ingresan los cruces de ventas.',
                                            dateTime: moment().format()
                                        };
                                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (this.costsChange && subcategory == 'produccion') {
                                                this.showNotificationError('Es necesario revisar los costos por ítem por esa razón ha sido redireccionado a esta sección.')
                                                this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                                            }
                                            else {
                                                if (subcategory == 'general') {
                                                    this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                    this.$router.push(this.routes.general);
                                                }
                                                else if (subcategory == 'transporte') {
                                                    this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                    this.$router.push(this.routes.transporte);
                                                }
                                                else if (subcategory == 'serviciogeneral') {
                                                    this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                    this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                                }
                                                else {
                                                    this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                }
                                            }
                                        }).catch((error) => {
                                            this.showNotificationError('Error escribiendo el log')
                                        });
                                    }
                                }).catch((error) => {
                                    this.showNotificationError('Error finalizando las ventas')
                                });
                            }).catch((error) => {
                                this.showNotificationError('Error agregando el mínimo de las ventas')
                            });
                        }).catch((error) => {
                            this.showNotificationError('Error agregando las ventas')
                        });
                    }
                    else if (callback.boolean == true){
                        var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: callback.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            this.$store.dispatch('setSalesData', this.$data).then(()=>{
                                var arrayComputed = [this.workdays_sales_computed,this.weekdays_sales_computed,this.months_sales_computed,this.products_sales_computed,this.average_monthly_sales_computed,this.services_sales_computed,this.historical_sales_computed,this.travel_sales_computed];
                                var   arrayFinalComputed = [];
                                for(let i=0;i<arrayComputed.length;i++){
                                    if(arrayComputed[i] != 0) {
                                        arrayFinalComputed.push(
                                            arrayComputed[i]
                                        )
                                    }
                                }
                                if(arrayFinalComputed.length != 0) {
                                    const minimumSales = Math.min(...arrayFinalComputed);
                                    this.$store.dispatch('setSalesDataComputed', this.final_minimum_sales_computed).then(()=>{
                                        this.$store.dispatch('setSalesDataPopulate', true).then(()=>{
                                            var payload = {
                                                stage: 'Ingreso de datos de negocio',
                                                description: 'Se ingresan los cruces de ventas con el siguiente mensaje: '+ callback.message,
                                                dateTime: moment().format()
                                            };
                                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate == false) {
                                                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                                    if (subcategory == 'general') {
                                                        this.$router.push(this.routes.general);
                                                    }
                                                    else if (subcategory == 'produccion') {
                                                        this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                                                    }
                                                    else if (subcategory == 'transporte') {
                                                        this.$router.push(this.routes.transporte);
                                                    }
                                                    else if (subcategory == 'serviciogeneral') {
                                                        this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                                    }
                                                }
                                                else {
                                                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                                    if (this.costsChange && subcategory == 'produccion') {
                                                        this.showNotificationError('Es necesario revisar los costos por ítem por esa razón ha sido redireccionado a esta sección.')
                                                        this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                                                    }
                                                    else {
                                                        if (subcategory == 'general') {
                                                            this.showNotificationError('Es necesario revisar los costos mensuales esa razón ha sido redireccionado a esta sección.')
                                                            this.$router.push(this.routes.general);
                                                        }
                                                        else if (subcategory == 'transporte') {
                                                            this.showNotificationError('Es necesario revisar los costos mensuales esa razón ha sido redireccionado a esta sección.')
                                                            this.$router.push(this.routes.transporte);
                                                        }
                                                        else if (subcategory == 'serviciogeneral') {
                                                            this.showNotificationError('Es necesario revisar los costos mensuales esa razón ha sido redireccionado a esta sección.')
                                                            this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                                        }
                                                        else {
                                                            this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                        }
                                                        
                                                    }
                                                }
                                            }).catch((error) => {
                                                this.showNotificationError('Error escribiendo el Log, hay alertas')
                                            });
                                        }).catch((error) => {
                                            this.showNotificationError('Error finalizando las ventas, hay alertas')
                                        });
                                    }).catch((error) => {
                                        this.showNotificationError('Error agregando el mínimo de las ventas, hay alertas')
                                    });  
                                }
                                else {
                                    var payload = {
                                        stage: 'Ingreso de datos de negocio',
                                        description: 'Se ingresan los cruces de ventas con el siguiente mensaje: '+ callback.message,
                                        dateTime: moment().format()
                                    };
                                    this.$store.dispatch('setChangeLog', payload).then(()=>{
                                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                                        if (subcategory == 'general') {
                                            this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                        }
                                        else if (subcategory == 'produccion') {
                                            this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                                        }
                                        else if (subcategory == 'transporte') {
                                            this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                        }
                                        else if (subcategory == 'serviciogeneral') {
                                            this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                        }
                                    }).catch((error) => {
                                        this.showNotificationError('Error agregando el Log, hay alertas')
                                    });
                                }
                            }).catch((error) => {
                                this.showNotificationError('Error agregando los datos de las ventas, hay alertas')
                            });
                        }, function (dismiss) {
                            
                        })
                    }
                    else {
                        this.showNotificationError('Ha ocurrido un error de callBack, contacta a soporte');
                    }
                }
                else if (this.$store.state.isSpouse) {
                    if (this.switches.historical == true && this.historical_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas mes base ha sido seleccionado, pero su valor es 0');
                        return   
                    }
                    if (this.switches.travel == true && this.travel_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas por viaje ha sido seleccionado, pero su valor es 0');
                        return   
                    }
                    if (this.switches.daily == true && this.workdays_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas diario ha sido seleccionado, pero su valor es 0');
                        return   
                    }
                    if (this.switches.weekly == true && this.weekdays_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas semanal ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.monthly == true && this.months_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas mensual ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.product == true && this.products_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas por producto ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.average == true && this.average_monthly_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas por promedio ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.service == true && this.services_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas de cantidad ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    var callback = this.confirmData();
                    if (callback.boolean == false) {
                        this.$store.dispatch('setSalesData', this.$data).then(()=>{
                            var arrayComputed = [this.workdays_sales_computed,this.weekdays_sales_computed,this.months_sales_computed,this.products_sales_computed,this.average_monthly_sales_computed,this.historical_sales_computed,this.travel_sales_computed];
                            var   arrayFinalComputed = [];
                            for(let i=0;i<arrayComputed.length;i++){
                                if(arrayComputed[i] != 0) {
                                    arrayFinalComputed.push(
                                        arrayComputed[i]
                                    )
                                }
                            }
                            const minimumSales = Math.min(...arrayFinalComputed);
                            if (this.final_minimum_sales_computed != this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem.length > 0) {
                                this.costsChange = true;
                            }
                            // this.$store.dispatch('setSalesDataComputed', minimumSales).then(()=>{
                            this.$store.dispatch('setSalesDataComputed', this.final_minimum_sales_computed).then(()=>{
                                this.$store.dispatch('setSalesDataPopulate', true).then(()=>{
                                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate == false) {
                                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                        var payload = {
                                            stage: 'Ingreso de datos de negocio',
                                            description: 'Se ingresan los cruces de ventas.',
                                            dateTime: moment().format()
                                        };
                                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (subcategory == 'general') {
                                                this.$router.push(this.routes.general);
                                            }
                                            else if (subcategory == 'produccion') {
                                                this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                                            }
                                            else if (subcategory == 'transporte') {
                                                this.$router.push(this.routes.transporte);
                                            }
                                            else if (subcategory == 'serviciogeneral') {
                                                this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                            }
                                        }).catch((error) => {
                                            this.showNotificationError('Error escribiendo el log')
                                        });
                                    }
                                    else {
                                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                        var payload = {
                                            stage: 'Ingreso de datos de negocio',
                                            description: 'Se ingresan los cruces de ventas.',
                                            dateTime: moment().format()
                                        };
                                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (this.costsChange && subcategory == 'produccion') {
                                                this.showNotificationError('Es necesario revisar los costos por ítem por esa razón ha sido redireccionado a esta sección.')
                                                this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                                            }
                                            else if (subcategory == 'general') {
                                                this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                this.$router.push(this.routes.general);
                                            }
                                            else if (subcategory == 'transporte') {
                                                this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                this.$router.push(this.routes.transporte);
                                            }
                                            else if (subcategory == 'serviciogeneral') {
                                                this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                            }
                                            else {
                                                this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                            }
                                        }).catch((error) => {
                                            this.showNotificationError('Error escribiendo el log')
                                        });
                                    }
                                }).catch((error) => {
                                    this.showNotificationError('Error finalizando las ventas')
                                });
                            }).catch((error) => {
                                this.showNotificationError('Error agregando el mínimo de las ventas')
                            });
                        }).catch((error) => {
                            this.showNotificationError('Error agregando las ventas')
                        });
                    }
                    else if (callback.boolean == true){
                        var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: callback.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            this.$store.dispatch('setSalesData', this.$data).then(()=>{
                                var arrayComputed = [this.workdays_sales_computed,this.weekdays_sales_computed,this.months_sales_computed,this.products_sales_computed,this.average_monthly_sales_computed,this.historical_sales_computed,this.travel_sales_computed];
                                var   arrayFinalComputed = [];
                                for(let i=0;i<arrayComputed.length;i++){
                                    if(arrayComputed[i] != 0) {
                                        arrayFinalComputed.push(
                                            arrayComputed[i]
                                        )
                                    }
                                }
                                if(arrayFinalComputed.length != 0) {
                                    const minimumSales = Math.min(...arrayFinalComputed);
                                    this.$store.dispatch('setSalesDataComputed', this.final_minimum_sales_computed).then(()=>{
                                        this.$store.dispatch('setSalesDataPopulate', true).then(()=>{
                                            var payload = {
                                                stage: 'Ingreso de datos de negocio',
                                                description: 'Se ingresan los cruces de ventas con el siguiente mensaje: '+ callback.message,
                                                dateTime: moment().format()
                                            };
                                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate == false) {
                                                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                                    if (subcategory == 'general') {
                                                        this.$router.push(this.routes.general);
                                                    }
                                                    else if (subcategory == 'produccion') {
                                                        this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                                                    }
                                                    else if (subcategory == 'transporte') {
                                                        this.$router.push(this.routes.transporte);
                                                    }
                                                    else if (subcategory == 'serviciogeneral') {
                                                        this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                                    }
                                                }
                                                else {
                                                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                                    if (this.costsChange && subcategory == 'produccion') {
                                                        this.showNotificationError('Es necesario revisar los costos por ítem por esa razón ha sido redireccionado a esta sección.')
                                                        this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                                                    }
                                                    else {
                                                        if (subcategory == 'general') {
                                                            this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                            this.$router.push(this.routes.general);
                                                        }
                                                        else if (subcategory == 'transporte') {
                                                            this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                            this.$router.push(this.routes.transporte);
                                                        }
                                                        else if (subcategory == 'serviciogeneral') {
                                                            this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                            this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                                        }
                                                        else {
                                                            this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                        }
                                                        
                                                    }
                                                }
                                            }).catch((error) => {
                                                this.showNotificationError('Error escribiendo el Log, hay alertas')
                                            });
                                        }).catch((error) => {
                                            this.showNotificationError('Error finalizando las ventas, hay alertas')
                                        });
                                    }).catch((error) => {
                                        this.showNotificationError('Error agregando el mínimo de las ventas, hay alertas')
                                    });  
                                }
                                else {
                                    var payload = {
                                        stage: 'Ingreso de datos de negocio',
                                        description: 'Se ingresan los cruces de ventas con el siguiente mensaje: '+ callback.message,
                                        dateTime: moment().format()
                                    };
                                    this.$store.dispatch('setChangeLog', payload).then(()=>{
                                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                                        if (subcategory == 'general') {
                                            this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                        }
                                        else if (subcategory == 'produccion') {
                                            this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                                        }
                                        else if (subcategory == 'transporte') {
                                            this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                        }
                                        else if (subcategory == 'serviciogeneral') {
                                            this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                        }
                                    }).catch((error) => {
                                        this.showNotificationError('Error agregando el Log, hay alertas')
                                    });
                                }
                            }).catch((error) => {
                                this.showNotificationError('Error agregando los datos de las ventas, hay alertas')
                            });
                        }, function (dismiss) {
                            
                        })
                    }
                    else {
                        this.showNotificationError('Ha ocurrido un error de callBack, contacta a soporte');
                    }
                }
                else if(this.$store.state.isGuarantor) {
                    if (this.switches.historical == true && this.historical_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas mes base ha sido seleccionado, pero su valor es 0');
                        return   
                    }
                    if (this.switches.travel == true && this.travel_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas por viaje ha sido seleccionado, pero su valor es 0');
                        return   
                    }
                    if (this.switches.daily == true && this.workdays_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas diario ha sido seleccionado, pero su valor es 0');
                        return   
                    }
                    if (this.switches.weekly == true && this.weekdays_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas semanal ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.monthly == true && this.months_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas mensual ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.product == true && this.products_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas por producto ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.average == true && this.average_monthly_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas por promedio ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    if (this.switches.service == true && this.services_sales_computed == 0) {
                        this.showNotificationError('El cruce de ventas de cantidad ha sido seleccionado, pero su valor es 0');
                        return
                    }
                    var callback = this.confirmData();
                    if (callback.boolean == false) {
                        this.$store.dispatch('setSalesData', this.$data).then(()=>{
                            var arrayComputed = [this.workdays_sales_computed,this.weekdays_sales_computed,this.months_sales_computed,this.products_sales_computed,this.average_monthly_sales_computed,this.historical_sales_computed,this.travel_sales_computed];
                            var   arrayFinalComputed = [];
                            for(let i=0;i<arrayComputed.length;i++){
                                if(arrayComputed[i] != 0) {
                                    arrayFinalComputed.push(
                                        arrayComputed[i]
                                    )
                                }
                            }
                            const minimumSales = Math.min(...arrayFinalComputed);
                            if (this.final_minimum_sales_computed != this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem.length > 0) {
                                this.costsChange = true;
                            }
                            // this.$store.dispatch('setSalesDataComputed', minimumSales).then(()=>{
                            this.$store.dispatch('setSalesDataComputed', this.final_minimum_sales_computed).then(()=>{
                                this.$store.dispatch('setSalesDataPopulate', true).then(()=>{
                                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate == false) {
                                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                        var payload = {
                                            stage: 'Ingreso de datos de negocio',
                                            description: 'Se ingresan los cruces de ventas.',
                                            dateTime: moment().format()
                                        };
                                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (subcategory == 'general') {
                                                this.$router.push(this.routes.general);
                                            }
                                            else if (subcategory == 'produccion') {
                                                this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                                            }
                                            else if (subcategory == 'transporte') {
                                                this.$router.push(this.routes.transporte);
                                            }
                                            else if (subcategory == 'serviciogeneral') {
                                                this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                            }
                                        }).catch((error) => {
                                            this.showNotificationError('Error escribiendo el log')
                                        });
                                    }
                                    else {
                                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                        var payload = {
                                            stage: 'Ingreso de datos de negocio',
                                            description: 'Se ingresan los cruces de ventas.',
                                            dateTime: moment().format()
                                        };
                                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                                            if (this.costsChange && subcategory == 'produccion') {
                                                this.showNotificationError('Es necesario revisar los costos por ítem por esa razón ha sido redireccionado a esta sección.')
                                                this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                                            }
                                            else {
                                                if (subcategory == 'general') {
                                                    this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                    this.$router.push(this.routes.general);
                                                }
                                                else if (subcategory == 'transporte') {
                                                    this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                    this.$router.push(this.routes.transporte);
                                                }
                                                else if (subcategory == 'serviciogeneral') {
                                                    this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                    this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                                }
                                                else {
                                                    this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                }
                                            }
                                        }).catch((error) => {
                                            this.showNotificationError('Error escribiendo el log')
                                        });
                                    }
                                }).catch((error) => {
                                    this.showNotificationError('Error finalizando las ventas')
                                });
                            }).catch((error) => {
                                this.showNotificationError('Error agregando el mínimo de las ventas')
                            });
                        }).catch((error) => {
                            this.showNotificationError('Error agregando las ventas')
                        });
                    }
                    else if (callback.boolean == true){
                        var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: callback.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            this.$store.dispatch('setSalesData', this.$data).then(()=>{
                                var arrayComputed = [this.workdays_sales_computed,this.weekdays_sales_computed,this.months_sales_computed,this.products_sales_computed,this.average_monthly_sales_computed,this.historical_sales_computed,this.travel_sales_computed];
                                var   arrayFinalComputed = [];
                                for(let i=0;i<arrayComputed.length;i++){
                                    if(arrayComputed[i] != 0) {
                                        arrayFinalComputed.push(
                                            arrayComputed[i]
                                        )
                                    }
                                }
                                if(arrayFinalComputed.length != 0) {
                                    const minimumSales = Math.min(...arrayFinalComputed);
                                    this.$store.dispatch('setSalesDataComputed', this.final_minimum_sales_computed).then(()=>{
                                        this.$store.dispatch('setSalesDataPopulate', true).then(()=>{
                                            var payload = {
                                                stage: 'Ingreso de datos de negocio',
                                                description: 'Se ingresan los cruces de ventas con el siguiente mensaje: '+ callback.message,
                                                dateTime: moment().format()
                                            };
                                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate == false) {
                                                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                                    if (subcategory == 'general') {
                                                        this.$router.push(this.routes.general);
                                                    }
                                                    else if (subcategory == 'produccion') {
                                                        this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                                                    }
                                                    else if (subcategory == 'transporte') {
                                                        this.$router.push(this.routes.transporte);
                                                    }
                                                    else if (subcategory == 'serviciogeneral') {
                                                        this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                                    }
                                                }
                                                else {
                                                    var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                                    if (this.costsChange && subcategory == 'produccion') {
                                                        this.showNotificationError('Es necesario revisar los costos por ítem por esa razón ha sido redireccionado a esta sección.')
                                                        this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                                                    }
                                                    else {
                                                        if (subcategory == 'general') {
                                                            this.showNotificationError('Es necesario revisar los costos mensuales de la línea por esa razón ha sido redireccionado a esta sección.')
                                                            this.$router.push(this.routes.general);
                                                        }
                                                        else {
                                                            if (subcategory == 'general') {
                                                                this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                                this.$router.push(this.routes.general);
                                                            }
                                                            else if (subcategory == 'transporte') {
                                                                this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                                this.$router.push(this.routes.transporte);
                                                            }
                                                            else if (subcategory == 'serviciogeneral') {
                                                                this.showNotificationError('Es necesario revisar los costos mensuales por esa razón ha sido redireccionado a esta sección.')
                                                                this.$router.push('/asessments/new_asessment/customer/costs/services/general');
                                                            }
                                                            else {
                                                                this.$router.push('/asessments/new_asessment/customer/others/business_references');
                                                            }
                                                        }
                                                        
                                                    }
                                                }
                                            }).catch((error) => {
                                                this.showNotificationError('Error escribiendo el Log, hay alertas')
                                            });
                                        }).catch((error) => {
                                            this.showNotificationError('Error finalizando las ventas, hay alertas')
                                        });
                                    }).catch((error) => {
                                        this.showNotificationError('Error agregando el mínimo de las ventas, hay alertas')
                                    });  
                                }
                                else {
                                    var payload = {
                                        stage: 'Ingreso de datos de negocio',
                                        description: 'Se ingresan los cruces de ventas con el siguiente mensaje: '+ callback.message,
                                        dateTime: moment().format()
                                    };
                                    this.$store.dispatch('setChangeLog', payload).then(()=>{
                                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                                        if (subcategory == 'general') {
                                            this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                        }
                                        else if (subcategory == 'produccion') {
                                            this.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                                        }
                                        else if (subcategory == 'transporte') {
                                            this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                        }
                                        else if (subcategory == 'serviciogeneral') {
                                            this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                        }
                                    }).catch((error) => {
                                        this.showNotificationError('Error agregando el Log, hay alertas')
                                    });
                                }
                            }).catch((error) => {
                                this.showNotificationError('Error agregando los datos de las ventas, hay alertas')
                            });
                        }, function (dismiss) {
                            
                        })
                    }
                    else {
                        this.showNotificationError('Ha ocurrido un error de callBack, contacta a soporte');
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            }
        },
        mounted () {
            this.ipc = this.$store.state.ipc;
            if (this.$store.state.isCustomer) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].pe_sales || null;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate) {
                    this.minimumSalesVar = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales;
                    this.switches = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].switches;
                    this.checkboxes = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].checkboxes;
                    this.weeks = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].weeks;
                    this.months = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].months;
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].products;
                    this.average = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].average;
                    this.services = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].services;
                    this.vehicles = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].vehicles;
                    this.historicalDate = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].historicalDate;
                    this.historical = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].sales[0].historical;
                }
                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                if (subcategory == 'produccion' && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem.length != 0) {
                    this.switches.product = true;
                    this.productsItem = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductionItem;
                }
                else if (subcategory == 'transporte') {
                    this.hideVehicles = false;
                }
            }
            else if (this.$store.state.isSpouse) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].pe_sales || null;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].salesPopulate) {
                    this.minimumSalesVar = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales;
                    this.switches = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].switches;
                    this.checkboxes = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].checkboxes;
                    this.weeks = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].weeks;
                    this.months = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].months;
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].products;
                    this.average = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].average;
                    this.services = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].services;
                    this.vehicles = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].vehicles;
                    this.historicalDate = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].historicalDate;
                    this.historical = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].sales[0].historical;
                }
                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].studySubcategory;
                if (subcategory == 'produccion' && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem.length != 0) {
                    this.switches.product = true;
                    this.productsItem = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductionItem;
                }
                else if (subcategory == 'transporte') {
                    this.hideVehicles = false;
                }
            }
            else if(this.$store.state.isGuarantor) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].pe_sales || null;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].salesPopulate) {
                    this.minimumSalesVar = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales;
                    this.switches = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].switches;
                    this.checkboxes = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].checkboxes;
                    this.weeks = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].weeks;
                    this.months = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].months;
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].products;
                    this.average = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].average;
                    this.services = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].services;
                    this.historical = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].historical;
                    this.vehicles = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].vehicles;
                    this.historicalDate = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].sales[0].historicalDate;
                }
                var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].studySubcategory;
                if (subcategory == 'produccion' && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem.length != 0) {
                    this.switches.product = true;
                    this.productsItem = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductionItem;
                }
                else if (subcategory == 'transporte') {
                    this.hideVehicles = false;
                }
            }

            
            if(this.$store.state.isCustomer) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType);
            }
            else if(this.$store.state.isSpouse) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].productType);
            }
            else if(this.$store.state.isGuarantor) {
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].productType);
            }
            if (product.name.toLowerCase() == 'pequeña empresa') {
                this.pyme = true;
            }
            this.initializeRoutes();
        }
    }
</script>
<style>
hr.hr-orange {
    border-top: 1px dashed orange;
}
.custom-input .el-input__inner {
  background-color: transparent;
  color: white;
}
.highlight-orange {
  font-weight: bold;
  color: orange;
}
.top-right-button {
  position: absolute;
  top: 10px; /* Ajusta el espacio desde el borde superior */
  right: 10px; /* Ajusta el espacio desde el borde derecho */
}
</style>
